(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cMmgH", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("4PYAy", function(module, exports) {

$parcel$export(module.exports, "Foundation", function () { return $385aec7348e0d9fe$export$1c94748c2f4f3b0c; });

var $cMmgH = parcelRequire("cMmgH");

var $5XiQP = parcelRequire("5XiQP");

var $cvxXx = parcelRequire("cvxXx");
var $385aec7348e0d9fe$var$FOUNDATION_VERSION = '6.9.0';
// Global Foundation object
// This is attached to the window, or used as a module for AMD/Browserify
var $385aec7348e0d9fe$export$1c94748c2f4f3b0c = {
    version: $385aec7348e0d9fe$var$FOUNDATION_VERSION,
    /**
   * Stores initialized plugins.
   */ _plugins: {},
    /**
   * Stores generated unique ids for plugin instances
   */ _uuids: [],
    /**
   * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
   * @param {Object} plugin - The constructor of the plugin.
   */ plugin: function(plugin, name) {
        // Object key to use when adding to global Foundation object
        // Examples: Foundation.Reveal, Foundation.OffCanvas
        var className = name || $385aec7348e0d9fe$var$functionName(plugin);
        // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
        // Examples: data-reveal, data-off-canvas
        var attrName = $385aec7348e0d9fe$var$hyphenate(className);
        // Add to the Foundation object and the plugins list (for reflowing)
        this._plugins[attrName] = this[className] = plugin;
    },
    /**
   * @function
   * Populates the _uuids array with pointers to each individual plugin instance.
   * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
   * Also fires the initialization event for each plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @param {String} name - the name of the plugin, passed as a camelCased string.
   * @fires Plugin#init
   */ registerPlugin: function(plugin, name) {
        var pluginName = name ? $385aec7348e0d9fe$var$hyphenate(name) : $385aec7348e0d9fe$var$functionName(plugin.constructor).toLowerCase();
        plugin.uuid = (0, $5XiQP.GetYoDigits)(6, pluginName);
        if (!plugin.$element.attr(`data-${pluginName}`)) plugin.$element.attr(`data-${pluginName}`, plugin.uuid);
        if (!plugin.$element.data('zfPlugin')) plugin.$element.data('zfPlugin', plugin);
        /**
           * Fires when the plugin has initialized.
           * @event Plugin#init
           */ plugin.$element.trigger(`init.zf.${pluginName}`);
        this._uuids.push(plugin.uuid);
        return;
    },
    /**
   * @function
   * Removes the plugins uuid from the _uuids array.
   * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
   * Also fires the destroyed event for the plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @fires Plugin#destroyed
   */ unregisterPlugin: function(plugin) {
        var pluginName = $385aec7348e0d9fe$var$hyphenate($385aec7348e0d9fe$var$functionName(plugin.$element.data('zfPlugin').constructor));
        this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
        plugin.$element.removeAttr(`data-${pluginName}`).removeData('zfPlugin')/**
           * Fires when the plugin has been destroyed.
           * @event Plugin#destroyed
           */ .trigger(`destroyed.zf.${pluginName}`);
        for(var prop in plugin)if (typeof plugin[prop] === 'function') plugin[prop] = null; //clean up script to prep for garbage collection.
        return;
    },
    /**
   * @function
   * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
   * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
   * @default If no argument is passed, reflow all currently active plugins.
   */ reInit: function(plugins) {
        var isJQ = plugins instanceof (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)));
        try {
            if (isJQ) plugins.each(function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data('zfPlugin')._init();
            });
            else {
                var type = typeof plugins, _this = this, fns = {
                    'object': function(plgs) {
                        plgs.forEach(function(p) {
                            p = $385aec7348e0d9fe$var$hyphenate(p);
                            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('[data-' + p + ']').foundation('_init');
                        });
                    },
                    'string': function() {
                        plugins = $385aec7348e0d9fe$var$hyphenate(plugins);
                        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('[data-' + plugins + ']').foundation('_init');
                    },
                    'undefined': function() {
                        this.object(Object.keys(_this._plugins));
                    }
                };
                fns[type](plugins);
            }
        } catch (err) {
            console.error(err);
        } finally{
            return plugins;
        }
    },
    /**
   * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
   * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
   * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
   */ reflow: function(elem, plugins) {
        // If plugins is undefined, just grab everything
        if (typeof plugins === 'undefined') plugins = Object.keys(this._plugins);
        else if (typeof plugins === 'string') plugins = [
            plugins
        ];
        var _this = this;
        // Iterate through each plugin
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).each(plugins, function(i, name) {
            // Get the current plugin
            var plugin = _this._plugins[name];
            // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(elem).find('[data-' + name + ']').addBack('[data-' + name + ']').filter(function() {
                return typeof (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data("zfPlugin") === 'undefined';
            });
            // For each plugin found, initialize it
            $elem.each(function() {
                var $el = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), opts = {
                    reflow: true
                };
                if ($el.attr('data-options')) $el.attr('data-options').split(';').forEach(function(option) {
                    var opt = option.split(':').map(function(el) {
                        return el.trim();
                    });
                    if (opt[0]) opts[opt[0]] = $385aec7348e0d9fe$var$parseValue(opt[1]);
                });
                try {
                    $el.data('zfPlugin', new plugin((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), opts));
                } catch (er) {
                    console.error(er);
                } finally{
                    return;
                }
            });
        });
    },
    getFnName: $385aec7348e0d9fe$var$functionName,
    addToJquery: function() {
        // TODO: consider not making this a jQuery function
        // TODO: need way to reflow vs. re-initialize
        /**
     * The Foundation jQuery method.
     * @param {String|Array} method - An action to perform on the current jQuery object.
     */ var foundation = function(method) {
            var type = typeof method, $noJS = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('.no-js');
            if ($noJS.length) $noJS.removeClass('no-js');
            if (type === 'undefined') {
                (0, $cvxXx.MediaQuery)._init();
                $385aec7348e0d9fe$export$1c94748c2f4f3b0c.reflow(this);
            } else if (type === 'string') {
                var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
                var plugClass = this.data('zfPlugin'); //determine the class of plugin
                if (typeof plugClass !== 'undefined' && typeof plugClass[method] !== 'undefined') {
                    if (this.length === 1) plugClass[method].apply(plugClass, args);
                    else this.each(function(i, el) {
                        plugClass[method].apply((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(el).data('zfPlugin'), args);
                    });
                } else throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? $385aec7348e0d9fe$var$functionName(plugClass) : 'this element') + '.');
            } else throw new TypeError(`We're sorry, ${type} is not a valid parameter. You must use a string representing the method you wish to invoke.`);
            return this;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).fn.foundation = foundation;
        return 0, (/*@__PURE__*/$parcel$interopDefault($cMmgH));
    }
};
$385aec7348e0d9fe$export$1c94748c2f4f3b0c.util = {
    /**
   * Function for applying a debounce effect to a function call.
   * @function
   * @param {Function} func - Function to be called at end of timeout.
   * @param {Number} delay - Time in ms to delay the call of `func`.
   * @returns function
   */ throttle: function(func, delay) {
        var timer = null;
        return function() {
            var context = this, args = arguments;
            if (timer === null) timer = setTimeout(function() {
                func.apply(context, args);
                timer = null;
            }, delay);
        };
    }
};
window.Foundation = $385aec7348e0d9fe$export$1c94748c2f4f3b0c;
// Polyfill for requestAnimationFrame
(function() {
    if (!Date.now || !window.Date.now) window.Date.now = Date.now = function() {
        return new Date().getTime();
    };
    var vendors = [
        'webkit',
        'moz'
    ];
    for(var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i){
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function(callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function() {
                callback(lastTime = nextTime);
            }, nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
    /**
   * Polyfill for performance.now, required by rAF
   */ if (!window.performance || !window.performance.now) window.performance = {
        start: Date.now(),
        now: function() {
            return Date.now() - this.start;
        }
    };
})();
if (!Function.prototype.bind) /* eslint-disable no-extend-native */ Function.prototype.bind = function(oThis) {
    if (typeof this !== 'function') // closest thing possible to the ECMAScript 5
    // internal IsCallable function
    throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    var aArgs = Array.prototype.slice.call(arguments, 1), fToBind = this, fNOP = function() {}, fBound = function() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    if (this.prototype) // native functions don't have a prototype
    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();
    return fBound;
};
// Polyfill to get the name of a function in IE9
function $385aec7348e0d9fe$var$functionName(fn) {
    if (typeof Function.prototype.name === 'undefined') {
        var funcNameRegex = /function\s([^(]{1,})\(/;
        var results = funcNameRegex.exec(fn.toString());
        return results && results.length > 1 ? results[1].trim() : "";
    } else if (typeof fn.prototype === 'undefined') return fn.constructor.name;
    else return fn.prototype.constructor.name;
}
function $385aec7348e0d9fe$var$parseValue(str) {
    if ('true' === str) return true;
    else if ('false' === str) return false;
    else if (!isNaN(str * 1)) return parseFloat(str);
    return str;
}
// Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580
function $385aec7348e0d9fe$var$hyphenate(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

});
parcelRegister("5XiQP", function(module, exports) {

$parcel$export(module.exports, "rtl", function () { return $456115db15b213e4$export$270f8a265cdb7a58; });
$parcel$export(module.exports, "GetYoDigits", function () { return $456115db15b213e4$export$3dcabfe640151a81; });
$parcel$export(module.exports, "RegExpEscape", function () { return $456115db15b213e4$export$f14d716b14dd66e2; });
$parcel$export(module.exports, "transitionend", function () { return $456115db15b213e4$export$a214e5a3a7081ff1; });
$parcel$export(module.exports, "onLoad", function () { return $456115db15b213e4$export$4e4d8b287d028b6b; });
$parcel$export(module.exports, "ignoreMousedisappear", function () { return $456115db15b213e4$export$43cd18ea5383b686; });

var $cMmgH = parcelRequire("cMmgH");
// Core Foundation Utilities, utilized in a number of places.
/**
   * Returns a boolean for RTL support
   */ function $456115db15b213e4$export$270f8a265cdb7a58() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('html').attr('dir') === 'rtl';
}
/**
 * returns a random base-36 uid with namespacing
 * @function
 * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
 * @param {String} namespace - name of plugin to be incorporated in uid, optional.
 * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
 * @returns {String} - unique id
 */ function $456115db15b213e4$export$3dcabfe640151a81(length = 6, namespace) {
    let str = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
    const charsLength = chars.length;
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * charsLength)];
    return namespace ? `${str}-${namespace}` : str;
}
/**
 * Escape a string so it can be used as a regexp pattern
 * @function
 * @see https://stackoverflow.com/a/9310752/4317384
 *
 * @param {String} str - string to escape.
 * @returns {String} - escaped string
 */ function $456115db15b213e4$export$f14d716b14dd66e2(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function $456115db15b213e4$export$a214e5a3a7081ff1($elem) {
    var transitions = {
        'transition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'otransitionend'
    };
    var elem = document.createElement('div'), end;
    for(let transition in transitions)if (typeof elem.style[transition] !== 'undefined') end = transitions[transition];
    if (end) return end;
    else {
        setTimeout(function() {
            $elem.triggerHandler('transitionend', [
                $elem
            ]);
        }, 1);
        return 'transitionend';
    }
}
/**
 * Return an event type to listen for window load.
 *
 * If `$elem` is passed, an event will be triggered on `$elem`. If window is already loaded, the event will still be triggered.
 * If `handler` is passed, attach it to the event on `$elem`.
 * Calling `onLoad` without handler allows you to get the event type that will be triggered before attaching the handler by yourself.
 * @function
 *
 * @param {Object} [] $elem - jQuery element on which the event will be triggered if passed.
 * @param {Function} [] handler - function to attach to the event.
 * @returns {String} - event type that should or will be triggered.
 */ function $456115db15b213e4$export$4e4d8b287d028b6b($elem, handler) {
    const didLoad = document.readyState === 'complete';
    const eventType = (didLoad ? '_didLoad' : 'load') + '.zf.util.onLoad';
    const cb = ()=>$elem.triggerHandler(eventType);
    if ($elem) {
        if (handler) $elem.one(eventType, handler);
        if (didLoad) setTimeout(cb);
        else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).one('load', cb);
    }
    return eventType;
}
/**
 * Retuns an handler for the `mouseleave` that ignore disappeared mouses.
 *
 * If the mouse "disappeared" from the document (like when going on a browser UI element, See https://git.io/zf-11410),
 * the event is ignored.
 * - If the `ignoreLeaveWindow` is `true`, the event is ignored when the user actually left the window
 *   (like by switching to an other window with [Alt]+[Tab]).
 * - If the `ignoreReappear` is `true`, the event will be ignored when the mouse will reappear later on the document
 *   outside of the element it left.
 *
 * @function
 *
 * @param {Function} [] handler - handler for the filtered `mouseleave` event to watch.
 * @param {Object} [] options - object of options:
 * - {Boolean} [false] ignoreLeaveWindow - also ignore when the user switched windows.
 * - {Boolean} [false] ignoreReappear - also ignore when the mouse reappeared outside of the element it left.
 * @returns {Function} - filtered handler to use to listen on the `mouseleave` event.
 */ function $456115db15b213e4$export$43cd18ea5383b686(handler, { ignoreLeaveWindow: ignoreLeaveWindow = false, ignoreReappear: ignoreReappear = false } = {}) {
    return function leaveEventHandler(eLeave, ...rest) {
        const callback = handler.bind(this, eLeave, ...rest);
        // The mouse left: call the given callback if the mouse entered elsewhere
        if (eLeave.relatedTarget !== null) return callback();
        // Otherwise, check if the mouse actually left the window.
        // In firefox if the user switched between windows, the window sill have the focus by the time
        // the event is triggered. We have to debounce the event to test this case.
        setTimeout(function leaveEventDebouncer() {
            if (!ignoreLeaveWindow && document.hasFocus && !document.hasFocus()) return callback();
            // Otherwise, wait for the mouse to reeapear outside of the element,
            if (!ignoreReappear) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document).one('mouseenter', function reenterEventHandler(eReenter) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(eLeave.currentTarget).has(eReenter.target).length) {
                    // Fill where the mouse finally entered.
                    eLeave.relatedTarget = eReenter.target;
                    callback();
                }
            });
        }, 0);
    };
}

});

parcelRegister("cvxXx", function(module, exports) {

$parcel$export(module.exports, "MediaQuery", function () { return $91b2b8e3e24cf344$export$b745838c41029eb3; });

var $cMmgH = parcelRequire("cMmgH");
// Default set of media queries
// const defaultQueries = {
//   'default' : 'only screen',
//   landscape : 'only screen and (orientation: landscape)',
//   portrait : 'only screen and (orientation: portrait)',
//   retina : 'only screen and (-webkit-min-device-pixel-ratio: 2),' +
//     'only screen and (min--moz-device-pixel-ratio: 2),' +
//     'only screen and (-o-min-device-pixel-ratio: 2/1),' +
//     'only screen and (min-device-pixel-ratio: 2),' +
//     'only screen and (min-resolution: 192dpi),' +
//     'only screen and (min-resolution: 2dppx)'
//   };
// matchMedia() polyfill - Test a CSS media type/query in JS.
// Authors & copyright © 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license
/* eslint-disable */ window.matchMedia || (window.matchMedia = function() {
    "use strict";
    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = window.styleMedia || window.media;
    // For those that don't support matchMedium
    if (!styleMedia) {
        var style = document.createElement('style'), script = document.getElementsByTagName('script')[0], info = null;
        style.type = 'text/css';
        style.id = 'matchmediajs-test';
        if (!script) document.head.appendChild(style);
        else script.parentNode.insertBefore(style, script);
        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;
        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) style.styleSheet.cssText = text;
                else style.textContent = text;
                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }
    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());
/* eslint-enable */ var $91b2b8e3e24cf344$export$b745838c41029eb3 = {
    queries: [],
    current: '',
    /**
   * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
   * @function
   * @private
   */ _init () {
        // make sure the initialization is only done once when calling _init() several times
        if (this.isInitialized === true) return this;
        else this.isInitialized = true;
        var self = this;
        var $meta = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('meta.foundation-mq');
        if (!$meta.length) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('<meta class="foundation-mq" name="foundation-mq" content>').appendTo(document.head);
        var extractedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('.foundation-mq').css('font-family');
        var namedQueries;
        namedQueries = $91b2b8e3e24cf344$var$parseStyleToObject(extractedStyles);
        self.queries = []; // reset
        for(var key in namedQueries)if (namedQueries.hasOwnProperty(key)) self.queries.push({
            name: key,
            value: `only screen and (min-width: ${namedQueries[key]})`
        });
        this.current = this._getCurrentSize();
        this._watcher();
    },
    /**
   * Reinitializes the media query helper.
   * Useful if your CSS breakpoint configuration has just been loaded or has changed since the initialization.
   * @function
   * @private
   */ _reInit () {
        this.isInitialized = false;
        this._init();
    },
    /**
   * Checks if the screen is at least as wide as a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
   */ atLeast (size) {
        var query = this.get(size);
        if (query) return window.matchMedia(query).matches;
        return false;
    },
    /**
   * Checks if the screen is within the given breakpoint.
   * If smaller than the breakpoint of larger than its upper limit it returns false.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` otherwise.
   */ only (size) {
        return size === this._getCurrentSize();
    },
    /**
   * Checks if the screen is within a breakpoint or smaller.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's larger.
   */ upTo (size) {
        const nextSize = this.next(size);
        // If the next breakpoint does not match, the screen is smaller than
        // the upper limit of this breakpoint.
        if (nextSize) return !this.atLeast(nextSize);
        // If there is no next breakpoint, the "size" breakpoint does not have
        // an upper limit and the screen will always be within it or smaller.
        return true;
    },
    /**
   * Checks if the screen matches to a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
   */ is (size) {
        const parts = size.trim().split(' ').filter((p)=>!!p.length);
        const [bpSize, bpModifier = ''] = parts;
        // Only the breakpont
        if (bpModifier === 'only') return this.only(bpSize);
        // At least the breakpoint (included)
        if (!bpModifier || bpModifier === 'up') return this.atLeast(bpSize);
        // Up to the breakpoint (included)
        if (bpModifier === 'down') return this.upTo(bpSize);
        throw new Error(`
      Invalid breakpoint passed to MediaQuery.is().
      Expected a breakpoint name formatted like "<size> <modifier>", got "${size}".
    `);
    },
    /**
   * Gets the media query of a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to get.
   * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
   */ get (size) {
        for(var i in this.queries)if (this.queries.hasOwnProperty(i)) {
            var query = this.queries[i];
            if (size === query.name) return query.value;
        }
        return null;
    },
    /**
   * Get the breakpoint following the given breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint.
   * @returns {String|null} - The name of the following breakpoint, or `null` if the passed breakpoint was the last one.
   */ next (size) {
        const queryIndex = this.queries.findIndex((q)=>this._getQueryName(q) === size);
        if (queryIndex === -1) throw new Error(`
        Unknown breakpoint "${size}" passed to MediaQuery.next().
        Ensure it is present in your Sass "$breakpoints" setting.
      `);
        const nextQuery = this.queries[queryIndex + 1];
        return nextQuery ? nextQuery.name : null;
    },
    /**
   * Returns the name of the breakpoint related to the given value.
   * @function
   * @private
   * @param {String|Object} value - Breakpoint name or query object.
   * @returns {String} Name of the breakpoint.
   */ _getQueryName (value) {
        if (typeof value === 'string') return value;
        if (typeof value === 'object') return value.name;
        throw new TypeError(`
      Invalid value passed to MediaQuery._getQueryName().
      Expected a breakpoint name (String) or a breakpoint query (Object), got "${value}" (${typeof value})
    `);
    },
    /**
   * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
   * @function
   * @private
   * @returns {String} Name of the current breakpoint.
   */ _getCurrentSize () {
        var matched;
        for(var i = 0; i < this.queries.length; i++){
            var query = this.queries[i];
            if (window.matchMedia(query.value).matches) matched = query;
        }
        return matched && this._getQueryName(matched);
    },
    /**
   * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
   * @function
   * @private
   */ _watcher () {
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).on('resize.zf.trigger', ()=>{
            var newSize = this._getCurrentSize(), currentSize = this.current;
            if (newSize !== currentSize) {
                // Change the current media query
                this.current = newSize;
                // Broadcast the media query change on the window
                (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).trigger('changed.zf.mediaquery', [
                    newSize,
                    currentSize
                ]);
            }
        });
    }
};
// Thank you: https://github.com/sindresorhus/query-string
function $91b2b8e3e24cf344$var$parseStyleToObject(str) {
    var styleObject = {};
    if (typeof str !== 'string') return styleObject;
    str = str.trim().slice(1, -1); // browsers re-quote string style values
    if (!str) return styleObject;
    styleObject = str.split('&').reduce(function(ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        var key = parts[0];
        var val = parts[1];
        key = decodeURIComponent(key);
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = typeof val === 'undefined' ? null : decodeURIComponent(val);
        if (!ret.hasOwnProperty(key)) ret[key] = val;
        else if (Array.isArray(ret[key])) ret[key].push(val);
        else ret[key] = [
            ret[key],
            val
        ];
        return ret;
    }, {});
    return styleObject;
}

});


parcelRegister("1DEAP", function(module, exports) {

$parcel$export(module.exports, "Box", function () { return $1318ebdeabb44211$export$e71c4d32a2263218; });
var $1318ebdeabb44211$export$e71c4d32a2263218 = {
    ImNotTouchingYou: $1318ebdeabb44211$var$ImNotTouchingYou,
    OverlapArea: $1318ebdeabb44211$var$OverlapArea,
    GetDimensions: $1318ebdeabb44211$var$GetDimensions,
    GetExplicitOffsets: $1318ebdeabb44211$var$GetExplicitOffsets
};
/**
 * Compares the dimensions of an element to a container and determines collision events with container.
 * @function
 * @param {jQuery} element - jQuery object to test for collisions.
 * @param {jQuery} parent - jQuery object to use as bounding container.
 * @param {Boolean} lrOnly - set to true to check left and right values only.
 * @param {Boolean} tbOnly - set to true to check top and bottom values only.
 * @default if no parent object passed, detects collisions with `window`.
 * @returns {Boolean} - true if collision free, false if a collision in any direction.
 */ function $1318ebdeabb44211$var$ImNotTouchingYou(element, parent, lrOnly, tbOnly, ignoreBottom) {
    return $1318ebdeabb44211$var$OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) === 0;
}
function $1318ebdeabb44211$var$OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) {
    var eleDims = $1318ebdeabb44211$var$GetDimensions(element), topOver, bottomOver, leftOver, rightOver;
    if (parent) {
        var parDims = $1318ebdeabb44211$var$GetDimensions(parent);
        bottomOver = parDims.height + parDims.offset.top - (eleDims.offset.top + eleDims.height);
        topOver = eleDims.offset.top - parDims.offset.top;
        leftOver = eleDims.offset.left - parDims.offset.left;
        rightOver = parDims.width + parDims.offset.left - (eleDims.offset.left + eleDims.width);
    } else {
        bottomOver = eleDims.windowDims.height + eleDims.windowDims.offset.top - (eleDims.offset.top + eleDims.height);
        topOver = eleDims.offset.top - eleDims.windowDims.offset.top;
        leftOver = eleDims.offset.left - eleDims.windowDims.offset.left;
        rightOver = eleDims.windowDims.width - (eleDims.offset.left + eleDims.width);
    }
    bottomOver = ignoreBottom ? 0 : Math.min(bottomOver, 0);
    topOver = Math.min(topOver, 0);
    leftOver = Math.min(leftOver, 0);
    rightOver = Math.min(rightOver, 0);
    if (lrOnly) return leftOver + rightOver;
    if (tbOnly) return topOver + bottomOver;
    // use sum of squares b/c we care about overlap area.
    return Math.sqrt(topOver * topOver + bottomOver * bottomOver + leftOver * leftOver + rightOver * rightOver);
}
/**
 * Uses native methods to return an object of dimension values.
 * @function
 * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
 * @returns {Object} - nested object of integer pixel values
 * TODO - if element is window, return only those values.
 */ function $1318ebdeabb44211$var$GetDimensions(elem) {
    elem = elem.length ? elem[0] : elem;
    if (elem === window || elem === document) throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
    var rect = elem.getBoundingClientRect(), parRect = elem.parentNode.getBoundingClientRect(), winRect = document.body.getBoundingClientRect(), winY = window.pageYOffset, winX = window.pageXOffset;
    return {
        width: rect.width,
        height: rect.height,
        offset: {
            top: rect.top + winY,
            left: rect.left + winX
        },
        parentDims: {
            width: parRect.width,
            height: parRect.height,
            offset: {
                top: parRect.top + winY,
                left: parRect.left + winX
            }
        },
        windowDims: {
            width: winRect.width,
            height: winRect.height,
            offset: {
                top: winY,
                left: winX
            }
        }
    };
}
/**
 * Returns an object of top and left integer pixel values for dynamically rendered elements,
 * such as: Tooltip, Reveal, and Dropdown. Maintained for backwards compatibility, and where
 * you don't know alignment, but generally from
 * 6.4 forward you should use GetExplicitOffsets, as GetOffsets conflates position and alignment.
 * @function
 * @param {jQuery} element - jQuery object for the element being positioned.
 * @param {jQuery} anchor - jQuery object for the element's anchor point.
 * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
 * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
 * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
 * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
 * TODO alter/rewrite to work with `em` values as well/instead of pixels
 */ function $1318ebdeabb44211$var$GetExplicitOffsets(element, anchor, position, alignment, vOffset, hOffset, isOverflow) {
    var $eleDims = $1318ebdeabb44211$var$GetDimensions(element), $anchorDims = anchor ? $1318ebdeabb44211$var$GetDimensions(anchor) : null;
    var topVal, leftVal;
    if ($anchorDims !== null) {
        // set position related attribute
        switch(position){
            case 'top':
                topVal = $anchorDims.offset.top - ($eleDims.height + vOffset);
                break;
            case 'bottom':
                topVal = $anchorDims.offset.top + $anchorDims.height + vOffset;
                break;
            case 'left':
                leftVal = $anchorDims.offset.left - ($eleDims.width + hOffset);
                break;
            case 'right':
                leftVal = $anchorDims.offset.left + $anchorDims.width + hOffset;
                break;
        }
        // set alignment related attribute
        switch(position){
            case 'top':
            case 'bottom':
                switch(alignment){
                    case 'left':
                        leftVal = $anchorDims.offset.left + hOffset;
                        break;
                    case 'right':
                        leftVal = $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset;
                        break;
                    case 'center':
                        leftVal = isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2 + hOffset;
                        break;
                }
                break;
            case 'right':
            case 'left':
                switch(alignment){
                    case 'bottom':
                        topVal = $anchorDims.offset.top - vOffset + $anchorDims.height - $eleDims.height;
                        break;
                    case 'top':
                        topVal = $anchorDims.offset.top + vOffset;
                        break;
                    case 'center':
                        topVal = $anchorDims.offset.top + vOffset + $anchorDims.height / 2 - $eleDims.height / 2;
                        break;
                }
                break;
        }
    }
    return {
        top: topVal,
        left: leftVal
    };
}

});

parcelRegister("kvWGb", function(module, exports) {

$parcel$export(module.exports, "Keyboard", function () { return $eef438617e4958b3$export$16e4d70cc375e707; });
/*******************************************
 *                                         *
 * This util was created by Marius Olbertz *
 * Please thank Marius on GitHub /owlbertz *
 * or the web http://www.mariusolbertz.de/ *
 *                                         *
 ******************************************/ 
var $cMmgH = parcelRequire("cMmgH");

var $5XiQP = parcelRequire("5XiQP");
const $eef438617e4958b3$var$keyCodes = {
    9: 'TAB',
    13: 'ENTER',
    27: 'ESCAPE',
    32: 'SPACE',
    35: 'END',
    36: 'HOME',
    37: 'ARROW_LEFT',
    38: 'ARROW_UP',
    39: 'ARROW_RIGHT',
    40: 'ARROW_DOWN'
};
var $eef438617e4958b3$var$commands = {};
// Functions pulled out to be referenceable from internals
function $eef438617e4958b3$var$findFocusable($element) {
    if (!$element) return false;
    return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).is(':visible') || (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).attr('tabindex') < 0) return false;
         //only have visible elements and those that have a tabindex greater or equal 0
        return true;
    }).sort(function(a, b) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(a).attr('tabindex') === (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(b).attr('tabindex')) return 0;
        let aTabIndex = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(a).attr('tabindex'), 10), bTabIndex = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(b).attr('tabindex'), 10);
        // Undefined is treated the same as 0
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(a).attr('tabindex') === 'undefined' && bTabIndex > 0) return 1;
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(b).attr('tabindex') === 'undefined' && aTabIndex > 0) return -1;
        if (aTabIndex === 0 && bTabIndex > 0) return 1;
        if (bTabIndex === 0 && aTabIndex > 0) return -1;
        if (aTabIndex < bTabIndex) return -1;
        if (aTabIndex > bTabIndex) return 1;
    });
}
function $eef438617e4958b3$var$parseKey(event) {
    var key = $eef438617e4958b3$var$keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, '');
    if (event.shiftKey) key = `SHIFT_${key}`;
    if (event.ctrlKey) key = `CTRL_${key}`;
    if (event.altKey) key = `ALT_${key}`;
    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, '');
    return key;
}
var $eef438617e4958b3$export$16e4d70cc375e707 = {
    keys: $eef438617e4958b3$var$getKeyCodes($eef438617e4958b3$var$keyCodes),
    /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */ parseKey: $eef438617e4958b3$var$parseKey,
    /**
   * Handles the given (keyboard) event
   * @param {Event} event - the event generated by the event handler
   * @param {String} component - Foundation component's name, e.g. Slider or Reveal
   * @param {Objects} functions - collection of functions that are to be executed
   */ handleKey (event, component, functions) {
        var commandList = $eef438617e4958b3$var$commands[component], keyCode = this.parseKey(event), cmds, command, fn;
        if (!commandList) return console.warn('Component not defined!');
        // Ignore the event if it was already handled
        if (event.zfIsKeyHandled === true) return;
        // This component does not differentiate between ltr and rtl
        if (typeof commandList.ltr === 'undefined') cmds = commandList; // use plain list
        else if ((0, $5XiQP.rtl)()) cmds = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend({}, commandList.ltr, commandList.rtl);
        else cmds = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend({}, commandList.rtl, commandList.ltr);
        command = cmds[keyCode];
        fn = functions[command];
        // Execute the handler if found
        if (fn && typeof fn === 'function') {
            var returnValue = fn.apply();
            // Mark the event as "handled" to prevent future handlings
            event.zfIsKeyHandled = true;
            // Execute function when event was handled
            if (functions.handled || typeof functions.handled === 'function') functions.handled(returnValue);
        } else // Execute function when event was not handled
        if (functions.unhandled || typeof functions.unhandled === 'function') functions.unhandled();
    },
    /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $element - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$element`
   */ findFocusable: $eef438617e4958b3$var$findFocusable,
    /**
   * Returns the component name name
   * @param {Object} component - Foundation component, e.g. Slider or Reveal
   * @return String componentName
   */ register (componentName, cmds) {
        $eef438617e4958b3$var$commands[componentName] = cmds;
    },
    // TODO9438: These references to Keyboard need to not require global. Will 'this' work in this context?
    //
    /**
   * Traps the focus in the given element.
   * @param  {jQuery} $element  jQuery object to trap the foucs into.
   */ trapFocus ($element) {
        var $focusable = $eef438617e4958b3$var$findFocusable($element), $firstFocusable = $focusable.eq(0), $lastFocusable = $focusable.eq(-1);
        $element.on('keydown.zf.trapfocus', function(event) {
            if (event.target === $lastFocusable[0] && $eef438617e4958b3$var$parseKey(event) === 'TAB') {
                event.preventDefault();
                $firstFocusable.focus();
            } else if (event.target === $firstFocusable[0] && $eef438617e4958b3$var$parseKey(event) === 'SHIFT_TAB') {
                event.preventDefault();
                $lastFocusable.focus();
            }
        });
    },
    /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $element  jQuery object to release the focus for.
   */ releaseFocus ($element) {
        $element.off('keydown.zf.trapfocus');
    }
};
/*
 * Constants for easier comparing.
 * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
 */ function $eef438617e4958b3$var$getKeyCodes(kcs) {
    var k = {};
    for(var kc in kcs)if (kcs.hasOwnProperty(kc)) k[kcs[kc]] = kcs[kc];
    return k;
}

});

parcelRegister("7pq6k", function(module, exports) {

$parcel$export(module.exports, "Nest", function () { return $564f1d576875d10a$export$b33048315ba1159e; });

var $cMmgH = parcelRequire("cMmgH");
const $564f1d576875d10a$export$b33048315ba1159e = {
    Feather (menu, type = 'zf') {
        menu.attr('role', 'menubar');
        menu.find('a').attr({
            'role': 'menuitem'
        });
        var items = menu.find('li').attr({
            'role': 'none'
        }), subMenuClass = `is-${type}-submenu`, subItemClass = `${subMenuClass}-item`, hasSubClass = `is-${type}-submenu-parent`, applyAria = type !== 'accordion'; // Accordions handle their own ARIA attriutes.
        items.each(function() {
            var $item = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), $sub = $item.children('ul');
            if ($sub.length) {
                $item.addClass(hasSubClass);
                if (applyAria) {
                    const firstItem = $item.children('a:first');
                    firstItem.attr({
                        'aria-haspopup': true,
                        'aria-label': firstItem.attr('aria-label') || firstItem.text()
                    });
                    // Note:  Drilldowns behave differently in how they hide, and so need
                    // additional attributes.  We should look if this possibly over-generalized
                    // utility (Nest) is appropriate when we rework menus in 6.4
                    if (type === 'drilldown') $item.attr({
                        'aria-expanded': false
                    });
                }
                $sub.addClass(`submenu ${subMenuClass}`).attr({
                    'data-submenu': '',
                    'role': 'menubar'
                });
                if (type === 'drilldown') $sub.attr({
                    'aria-hidden': true
                });
            }
            if ($item.parent('[data-submenu]').length) $item.addClass(`is-submenu-item ${subItemClass}`);
        });
        return;
    },
    Burn (menu, type) {
        var subMenuClass = `is-${type}-submenu`, subItemClass = `${subMenuClass}-item`, hasSubClass = `is-${type}-submenu-parent`;
        menu.find('>li, > li > ul, .menu, .menu > li, [data-submenu] > li').removeClass(`${subMenuClass} ${subItemClass} ${hasSubClass} is-submenu-item submenu is-active`).removeAttr('data-submenu').css('display', '');
    }
};

});

parcelRegister("aNFr7", function(module, exports) {

$parcel$export(module.exports, "Touch", function () { return $7dce9f605544bee6$export$746b04bbf92762fd; });
//**************************************************
//**Work inspired by multiple jquery swipe plugins**
//**Done by Yohai Ararat ***************************
//**************************************************

var $cMmgH = parcelRequire("cMmgH");
var $7dce9f605544bee6$export$746b04bbf92762fd = {};
var $7dce9f605544bee6$var$startPosX, $7dce9f605544bee6$var$startTime, $7dce9f605544bee6$var$elapsedTime, $7dce9f605544bee6$var$startEvent, $7dce9f605544bee6$var$isMoving = false, $7dce9f605544bee6$var$didMoved = false;
function $7dce9f605544bee6$var$onTouchEnd(e) {
    this.removeEventListener('touchmove', $7dce9f605544bee6$var$onTouchMove);
    this.removeEventListener('touchend', $7dce9f605544bee6$var$onTouchEnd);
    // If the touch did not move, consider it as a "tap"
    if (!$7dce9f605544bee6$var$didMoved) {
        var tapEvent = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).Event('tap', $7dce9f605544bee6$var$startEvent || e);
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).trigger(tapEvent);
    }
    $7dce9f605544bee6$var$startEvent = null;
    $7dce9f605544bee6$var$isMoving = false;
    $7dce9f605544bee6$var$didMoved = false;
}
function $7dce9f605544bee6$var$onTouchMove(e) {
    if (true === (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe.preventDefault) e.preventDefault();
    if ($7dce9f605544bee6$var$isMoving) {
        var x = e.touches[0].pageX;
        // var y = e.touches[0].pageY;
        var dx = $7dce9f605544bee6$var$startPosX - x;
        // var dy = startPosY - y;
        var dir;
        $7dce9f605544bee6$var$didMoved = true;
        $7dce9f605544bee6$var$elapsedTime = new Date().getTime() - $7dce9f605544bee6$var$startTime;
        if (Math.abs(dx) >= (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe.moveThreshold && $7dce9f605544bee6$var$elapsedTime <= (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe.timeThreshold) dir = dx > 0 ? 'left' : 'right';
        // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
        //   dir = dy > 0 ? 'down' : 'up';
        // }
        if (dir) {
            e.preventDefault();
            $7dce9f605544bee6$var$onTouchEnd.apply(this, arguments);
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).trigger((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).Event('swipe', Object.assign({}, e)), dir).trigger((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).Event(`swipe${dir}`, Object.assign({}, e)));
        }
    }
}
function $7dce9f605544bee6$var$onTouchStart(e) {
    if (e.touches.length === 1) {
        $7dce9f605544bee6$var$startPosX = e.touches[0].pageX;
        $7dce9f605544bee6$var$startEvent = e;
        $7dce9f605544bee6$var$isMoving = true;
        $7dce9f605544bee6$var$didMoved = false;
        $7dce9f605544bee6$var$startTime = new Date().getTime();
        this.addEventListener('touchmove', $7dce9f605544bee6$var$onTouchMove, {
            passive: true === (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe.preventDefault
        });
        this.addEventListener('touchend', $7dce9f605544bee6$var$onTouchEnd, false);
    }
}
function $7dce9f605544bee6$var$init() {
    this.addEventListener && this.addEventListener('touchstart', $7dce9f605544bee6$var$onTouchStart, {
        passive: true
    });
}
// function teardown() {
//   this.removeEventListener('touchstart', onTouchStart);
// }
class $7dce9f605544bee6$var$SpotSwipe {
    constructor(){
        this.version = '1.0.0';
        this.enabled = 'ontouchstart' in document.documentElement;
        this.preventDefault = false;
        this.moveThreshold = 75;
        this.timeThreshold = 200;
        this._init();
    }
    _init() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).event.special.swipe = {
            setup: $7dce9f605544bee6$var$init
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).event.special.tap = {
            setup: $7dce9f605544bee6$var$init
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).each([
            'left',
            'up',
            'down',
            'right'
        ], function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).event.special[`swipe${this}`] = {
                setup: function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).on('swipe', (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).noop);
                }
            };
        });
    }
}
/****************************************************
 * As far as I can tell, both setupSpotSwipe and    *
 * setupTouchHandler should be idempotent,          *
 * because they directly replace functions &        *
 * values, and do not add event handlers directly.  *
 ****************************************************/ $7dce9f605544bee6$export$746b04bbf92762fd.setupSpotSwipe = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe = new $7dce9f605544bee6$var$SpotSwipe((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))));
};
/****************************************************
 * Method for adding pseudo drag events to elements *
 ***************************************************/ $7dce9f605544bee6$export$746b04bbf92762fd.setupTouchHandler = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).fn.addTouch = function() {
        this.each(function(i, el) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(el).bind('touchstart touchmove touchend touchcancel', function(event) {
                //we pass the original event object because the jQuery event
                //object is normalized to w3c specs and does not provide the TouchList
                handleTouch(event);
            });
        });
        var handleTouch = function(event) {
            var touches = event.changedTouches, first = touches[0], eventTypes = {
                touchstart: 'mousedown',
                touchmove: 'mousemove',
                touchend: 'mouseup'
            }, type = eventTypes[event.type], simulatedEvent;
            if ('MouseEvent' in window && typeof window.MouseEvent === 'function') simulatedEvent = new window.MouseEvent(type, {
                'bubbles': true,
                'cancelable': true,
                'screenX': first.screenX,
                'screenY': first.screenY,
                'clientX': first.clientX,
                'clientY': first.clientY
            });
            else {
                simulatedEvent = document.createEvent('MouseEvent');
                simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0 /*left*/ , null);
            }
            first.target.dispatchEvent(simulatedEvent);
        };
    };
};
$7dce9f605544bee6$export$746b04bbf92762fd.init = function() {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).spotSwipe === 'undefined') {
        $7dce9f605544bee6$export$746b04bbf92762fd.setupSpotSwipe((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))));
        $7dce9f605544bee6$export$746b04bbf92762fd.setupTouchHandler((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))));
    }
};

});

parcelRegister("5EyIV", function(module, exports) {

$parcel$export(module.exports, "Triggers", function () { return $41db9f8974180743$export$2f0ccbe60836e02e; });

var $cMmgH = parcelRequire("cMmgH");

var $5XiQP = parcelRequire("5XiQP");

var $lNiiG = parcelRequire("lNiiG");
const $41db9f8974180743$var$MutationObserver = function() {
    var prefixes = [
        'WebKit',
        'Moz',
        'O',
        'Ms',
        ''
    ];
    for(var i = 0; i < prefixes.length; i++){
        if (`${prefixes[i]}MutationObserver` in window) return window[`${prefixes[i]}MutationObserver`];
    }
    return false;
}();
const $41db9f8974180743$var$triggers = (el, type)=>{
    el.data(type).split(' ').forEach((id)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(`#${id}`)[type === 'close' ? 'trigger' : 'triggerHandler'](`${type}.zf.trigger`, [
            el
        ]);
    });
};
var $41db9f8974180743$export$2f0ccbe60836e02e = {
    Listeners: {
        Basic: {},
        Global: {}
    },
    Initializers: {}
};
$41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic = {
    openListener: function() {
        $41db9f8974180743$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), 'open');
    },
    closeListener: function() {
        let id = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data('close');
        if (id) $41db9f8974180743$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), 'close');
        else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).trigger('close.zf.trigger');
    },
    toggleListener: function() {
        let id = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data('toggle');
        if (id) $41db9f8974180743$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), 'toggle');
        else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).trigger('toggle.zf.trigger');
    },
    closeableListener: function(e) {
        let animation = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data('closable');
        // Only close the first closable element. See https://git.io/zf-7833
        e.stopPropagation();
        if (animation !== '') (0, $lNiiG.Motion).animateOut((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), animation, function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).trigger('closed.zf');
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).fadeOut().trigger('closed.zf');
    },
    toggleFocusListener: function() {
        let id = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).data('toggle-focus');
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(`#${id}`).triggerHandler('toggle.zf.trigger', [
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this)
        ]);
    }
};
// Elements with [data-open] will reveal a plugin that supports it when clicked.
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addOpenListener = ($elem)=>{
    $elem.off('click.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.openListener);
    $elem.on('click.zf.trigger', '[data-open]', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.openListener);
};
// Elements with [data-close] will close a plugin that supports it when clicked.
// If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addCloseListener = ($elem)=>{
    $elem.off('click.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.closeListener);
    $elem.on('click.zf.trigger', '[data-close]', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.closeListener);
};
// Elements with [data-toggle] will toggle a plugin that supports it when clicked.
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addToggleListener = ($elem)=>{
    $elem.off('click.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.toggleListener);
    $elem.on('click.zf.trigger', '[data-toggle]', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.toggleListener);
};
// Elements with [data-closable] will respond to close.zf.trigger events.
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addCloseableListener = ($elem)=>{
    $elem.off('close.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.closeableListener);
    $elem.on('close.zf.trigger', '[data-closeable], [data-closable]', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.closeableListener);
};
// Elements with [data-toggle-focus] will respond to coming in and out of focus
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addToggleFocusListener = ($elem)=>{
    $elem.off('focus.zf.trigger blur.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.toggleFocusListener);
    $elem.on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Basic.toggleFocusListener);
};
// More Global/complex listeners and triggers
$41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Global = {
    resizeListener: function($nodes) {
        if (!$41db9f8974180743$var$MutationObserver) $nodes.each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).triggerHandler('resizeme.zf.trigger');
        });
        //trigger all listening elements and signal a resize event
        $nodes.attr('data-events', "resize");
    },
    scrollListener: function($nodes) {
        if (!$41db9f8974180743$var$MutationObserver) $nodes.each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).triggerHandler('scrollme.zf.trigger');
        });
        //trigger all listening elements and signal a scroll event
        $nodes.attr('data-events', "scroll");
    },
    closeMeListener: function(e, pluginId) {
        let plugin = e.namespace.split('.')[0];
        let plugins = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(`[data-${plugin}]`).not(`[data-yeti-box="${pluginId}"]`);
        plugins.each(function() {
            let _this = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this);
            _this.triggerHandler('close.zf.trigger', [
                _this
            ]);
        });
    }
};
// Global, parses whole document.
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addClosemeListener = function(pluginName) {
    var yetiBoxes = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('[data-yeti-box]'), plugNames = [
        'dropdown',
        'tooltip',
        'reveal'
    ];
    if (pluginName) {
        if (typeof pluginName === 'string') plugNames.push(pluginName);
        else if (typeof pluginName === 'object' && typeof pluginName[0] === 'string') plugNames = plugNames.concat(pluginName);
        else console.error('Plugin names must be strings');
    }
    if (yetiBoxes.length) {
        let listeners = plugNames.map((name)=>{
            return `closeme.zf.${name}`;
        }).join(' ');
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).off(listeners).on(listeners, $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Global.closeMeListener);
    }
};
function $41db9f8974180743$var$debounceGlobalListener(debounce, trigger, listener) {
    let timer, args = Array.prototype.slice.call(arguments, 3);
    (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).on(trigger, function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            listener.apply(null, args);
        }, debounce || 10); //default time to emit scroll event
    });
}
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addResizeListener = function(debounce) {
    let $nodes = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('[data-resize]');
    if ($nodes.length) $41db9f8974180743$var$debounceGlobalListener(debounce, 'resize.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Global.resizeListener, $nodes);
};
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addScrollListener = function(debounce) {
    let $nodes = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('[data-scroll]');
    if ($nodes.length) $41db9f8974180743$var$debounceGlobalListener(debounce, 'scroll.zf.trigger', $41db9f8974180743$export$2f0ccbe60836e02e.Listeners.Global.scrollListener, $nodes);
};
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addMutationEventsListener = function($elem) {
    if (!$41db9f8974180743$var$MutationObserver) return false;
    let $nodes = $elem.find('[data-resize], [data-scroll], [data-mutate]');
    //element callback
    var listeningElementsMutation = function(mutationRecordsList) {
        var $target = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(mutationRecordsList[0].target);
        //trigger the event handler for the element depending on type
        switch(mutationRecordsList[0].type){
            case "attributes":
                if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") $target.triggerHandler('scrollme.zf.trigger', [
                    $target,
                    window.pageYOffset
                ]);
                if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") $target.triggerHandler('resizeme.zf.trigger', [
                    $target
                ]);
                if (mutationRecordsList[0].attributeName === "style") {
                    $target.closest("[data-mutate]").attr("data-events", "mutate");
                    $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [
                        $target.closest("[data-mutate]")
                    ]);
                }
                break;
            case "childList":
                $target.closest("[data-mutate]").attr("data-events", "mutate");
                $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [
                    $target.closest("[data-mutate]")
                ]);
                break;
            default:
                return false;
        }
    };
    if ($nodes.length) //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
    for(var i = 0; i <= $nodes.length - 1; i++){
        var elementObserver = new $41db9f8974180743$var$MutationObserver(listeningElementsMutation);
        elementObserver.observe($nodes[i], {
            attributes: true,
            childList: true,
            characterData: false,
            subtree: true,
            attributeFilter: [
                "data-events",
                "style"
            ]
        });
    }
};
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addSimpleListeners = function() {
    let $document = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addOpenListener($document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addCloseListener($document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addToggleListener($document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addCloseableListener($document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addToggleFocusListener($document);
};
$41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addGlobalListeners = function() {
    let $document = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addMutationEventsListener($document);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addResizeListener(250);
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addScrollListener();
    $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addClosemeListener();
};
$41db9f8974180743$export$2f0ccbe60836e02e.init = function(__, Foundation) {
    (0, $5XiQP.onLoad)((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window), function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).triggersInitialized !== true) {
            $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addSimpleListeners();
            $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addGlobalListeners();
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).triggersInitialized = true;
        }
    });
    if (Foundation) {
        Foundation.Triggers = $41db9f8974180743$export$2f0ccbe60836e02e;
        // Legacy included to be backwards compatible for now.
        Foundation.IHearYou = $41db9f8974180743$export$2f0ccbe60836e02e.Initializers.addGlobalListeners;
    }
};

});
parcelRegister("lNiiG", function(module, exports) {

$parcel$export(module.exports, "Motion", function () { return $fddc5ea18dcc2cab$export$ab7b018719e111db; });
$parcel$export(module.exports, "Move", function () { return $fddc5ea18dcc2cab$export$e49a5ad3dd6df925; });

var $cMmgH = parcelRequire("cMmgH");

var $5XiQP = parcelRequire("5XiQP");
/**
 * Motion module.
 * @module foundation.motion
 */ const $fddc5ea18dcc2cab$var$initClasses = [
    'mui-enter',
    'mui-leave'
];
const $fddc5ea18dcc2cab$var$activeClasses = [
    'mui-enter-active',
    'mui-leave-active'
];
const $fddc5ea18dcc2cab$export$ab7b018719e111db = {
    animateIn: function(element, animation, cb) {
        $fddc5ea18dcc2cab$var$animate(true, element, animation, cb);
    },
    animateOut: function(element, animation, cb) {
        $fddc5ea18dcc2cab$var$animate(false, element, animation, cb);
    }
};
function $fddc5ea18dcc2cab$export$e49a5ad3dd6df925(duration, elem, fn) {
    var anim, prog, start = null;
    if (duration === 0) {
        fn.apply(elem);
        elem.trigger('finished.zf.animate', [
            elem
        ]).triggerHandler('finished.zf.animate', [
            elem
        ]);
        return;
    }
    function move(ts) {
        if (!start) start = ts;
        prog = ts - start;
        fn.apply(elem);
        if (prog < duration) anim = window.requestAnimationFrame(move, elem);
        else {
            window.cancelAnimationFrame(anim);
            elem.trigger('finished.zf.animate', [
                elem
            ]).triggerHandler('finished.zf.animate', [
                elem
            ]);
        }
    }
    anim = window.requestAnimationFrame(move);
}
/**
 * Animates an element in or out using a CSS transition class.
 * @function
 * @private
 * @param {Boolean} isIn - Defines if the animation is in or out.
 * @param {Object} element - jQuery or HTML object to animate.
 * @param {String} animation - CSS class to use.
 * @param {Function} cb - Callback to run when animation is finished.
 */ function $fddc5ea18dcc2cab$var$animate(isIn, element, animation, cb) {
    element = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(element).eq(0);
    if (!element.length) return;
    var initClass = isIn ? $fddc5ea18dcc2cab$var$initClasses[0] : $fddc5ea18dcc2cab$var$initClasses[1];
    var activeClass = isIn ? $fddc5ea18dcc2cab$var$activeClasses[0] : $fddc5ea18dcc2cab$var$activeClasses[1];
    // Set up the animation
    reset();
    element.addClass(animation).css('transition', 'none');
    requestAnimationFrame(()=>{
        element.addClass(initClass);
        if (isIn) element.show();
    });
    // Start the animation
    requestAnimationFrame(()=>{
        // will trigger the browser to synchronously calculate the style and layout
        // also called reflow or layout thrashing
        // see https://gist.github.com/paulirish/5d52fb081b3570c81e3a
        element[0].offsetWidth;
        element.css('transition', '').addClass(activeClass);
    });
    // Clean up the animation when it finishes
    element.one((0, $5XiQP.transitionend)(element), finish);
    // Hides the element (for out animations), resets the element, and runs a callback
    function finish() {
        if (!isIn) element.hide();
        reset();
        if (cb) cb.apply(element);
    }
    // Resets transitions and removes motion-specific classes
    function reset() {
        element[0].style.transitionDuration = 0;
        element.removeClass(`${initClass} ${activeClass} ${animation}`);
    }
}

});


parcelRegister("jEMkX", function(module, exports) {

$parcel$export(module.exports, "AccordionMenu", function () { return $e4f73f756a153fc9$export$6abe07ec29339e67; });

var $cMmgH = parcelRequire("cMmgH");

var $kvWGb = parcelRequire("kvWGb");

var $7pq6k = parcelRequire("7pq6k");

var $5XiQP = parcelRequire("5XiQP");

var $7hXZi = parcelRequire("7hXZi");
/**
 * AccordionMenu module.
 * @module foundation.accordionMenu
 * @requires foundation.util.keyboard
 * @requires foundation.util.nest
 */ class $e4f73f756a153fc9$export$6abe07ec29339e67 extends (0, $7hXZi.Plugin) {
    /**
   * Creates a new instance of an accordion menu.
   * @class
   * @name AccordionMenu
   * @fires AccordionMenu#init
   * @param {jQuery} element - jQuery object to make into an accordion menu.
   * @param {Object} options - Overrides to the default plugin settings.
   */ _setup(element, options) {
        this.$element = element;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend({}, $e4f73f756a153fc9$export$6abe07ec29339e67.defaults, this.$element.data(), options);
        this.className = 'AccordionMenu'; // ie9 back compat
        this._init();
        (0, $kvWGb.Keyboard).register('AccordionMenu', {
            'ENTER': 'toggle',
            'SPACE': 'toggle',
            'ARROW_RIGHT': 'open',
            'ARROW_UP': 'up',
            'ARROW_DOWN': 'down',
            'ARROW_LEFT': 'close',
            'ESCAPE': 'closeAll'
        });
    }
    /**
   * Initializes the accordion menu by hiding all nested menus.
   * @private
   */ _init() {
        (0, $7pq6k.Nest).Feather(this.$element, 'accordion');
        var _this = this;
        this.$element.find('[data-submenu]').not('.is-active').slideUp(0); //.find('a').css('padding-left', '1rem');
        this.$element.attr({
            'aria-multiselectable': this.options.multiOpen
        });
        this.$menuLinks = this.$element.find('.is-accordion-submenu-parent');
        this.$menuLinks.each(function() {
            var linkId = this.id || (0, $5XiQP.GetYoDigits)(6, 'acc-menu-link'), $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), $sub = $elem.children('[data-submenu]'), subId = $sub[0].id || (0, $5XiQP.GetYoDigits)(6, 'acc-menu'), isActive = $sub.hasClass('is-active');
            if (_this.options.parentLink) {
                let $anchor = $elem.children('a');
                $anchor.clone().prependTo($sub).wrap('<li data-is-parent-link class="is-submenu-parent-item is-submenu-item is-accordion-submenu-item"></li>');
            }
            if (_this.options.submenuToggle) {
                $elem.addClass('has-submenu-toggle');
                $elem.children('a').after('<button id="' + linkId + '" class="submenu-toggle" aria-controls="' + subId + '" aria-expanded="' + isActive + '" title="' + _this.options.submenuToggleText + '"><span class="submenu-toggle-text">' + _this.options.submenuToggleText + '</span></button>');
            } else $elem.attr({
                'aria-controls': subId,
                'aria-expanded': isActive,
                'id': linkId
            });
            $sub.attr({
                'aria-labelledby': linkId,
                'aria-hidden': !isActive,
                'role': 'group',
                'id': subId
            });
        });
        var initPanes = this.$element.find('.is-active');
        if (initPanes.length) initPanes.each(function() {
            _this.down((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this));
        });
        this._events();
    }
    /**
   * Adds event handlers for items within the menu.
   * @private
   */ _events() {
        var _this = this;
        this.$element.find('li').each(function() {
            var $submenu = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).children('[data-submenu]');
            if ($submenu.length) {
                if (_this.options.submenuToggle) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).children('.submenu-toggle').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function() {
                    _this.toggle($submenu);
                });
                else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).children('a').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function(e) {
                    e.preventDefault();
                    _this.toggle($submenu);
                });
            }
        }).on('keydown.zf.accordionMenu', function(e) {
            var $element = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), $elements = $element.parent('ul').children('li'), $prevElement, $nextElement, $target = $element.children('[data-submenu]');
            $elements.each(function(i) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).is($element)) {
                    $prevElement = $elements.eq(Math.max(0, i - 1)).find('a').first();
                    $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1)).find('a').first();
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).children('[data-submenu]:visible').length) $nextElement = $element.find('li:first-child').find('a').first();
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).is(':first-child')) $prevElement = $element.parents('li').first().find('a').first();
                    else if ($prevElement.parents('li').first().children('[data-submenu]:visible').length) $prevElement = $prevElement.parents('li').find('li:last-child').find('a').first();
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).is(':last-child')) $nextElement = $element.parents('li').first().next('li').find('a').first();
                    return;
                }
            });
            (0, $kvWGb.Keyboard).handleKey(e, 'AccordionMenu', {
                open: function() {
                    if ($target.is(':hidden')) {
                        _this.down($target);
                        $target.find('li').first().find('a').first().focus();
                    }
                },
                close: function() {
                    if ($target.length && !$target.is(':hidden')) _this.up($target);
                    else if ($element.parent('[data-submenu]').length) {
                        _this.up($element.parent('[data-submenu]'));
                        $element.parents('li').first().find('a').first().focus();
                    }
                },
                up: function() {
                    $prevElement.focus();
                    return true;
                },
                down: function() {
                    $nextElement.focus();
                    return true;
                },
                toggle: function() {
                    if (_this.options.submenuToggle) return false;
                    if ($element.children('[data-submenu]').length) {
                        _this.toggle($element.children('[data-submenu]'));
                        return true;
                    }
                },
                closeAll: function() {
                    _this.hideAll();
                },
                handled: function(preventDefault) {
                    if (preventDefault) e.preventDefault();
                }
            });
        }); //.attr('tabindex', 0);
    }
    /**
   * Closes all panes of the menu.
   * @function
   */ hideAll() {
        this.up(this.$element.find('[data-submenu]'));
    }
    /**
   * Opens all panes of the menu.
   * @function
   */ showAll() {
        this.down(this.$element.find('[data-submenu]'));
    }
    /**
   * Toggles the open/close state of a submenu.
   * @function
   * @param {jQuery} $target - the submenu to toggle
   */ toggle($target) {
        if (!$target.is(':animated')) {
            if (!$target.is(':hidden')) this.up($target);
            else this.down($target);
        }
    }
    /**
   * Opens the sub-menu defined by `$target`.
   * @param {jQuery} $target - Sub-menu to open.
   * @fires AccordionMenu#down
   */ down($target) {
        // If having multiple submenus active is disabled, close all the submenus
        // that are not parents or children of the targeted submenu.
        if (!this.options.multiOpen) {
            // The "branch" of the targetted submenu, from the component root to
            // the active submenus nested in it.
            const $targetBranch = $target.parentsUntil(this.$element).add($target).add($target.find('.is-active'));
            // All the active submenus that are not in the branch.
            const $othersActiveSubmenus = this.$element.find('.is-active').not($targetBranch);
            this.up($othersActiveSubmenus);
        }
        $target.addClass('is-active').attr({
            'aria-hidden': false
        });
        if (this.options.submenuToggle) $target.prev('.submenu-toggle').attr({
            'aria-expanded': true
        });
        else $target.parent('.is-accordion-submenu-parent').attr({
            'aria-expanded': true
        });
        $target.slideDown(this.options.slideSpeed, ()=>{
            /**
       * Fires when the menu is done opening.
       * @event AccordionMenu#down
       */ this.$element.trigger('down.zf.accordionMenu', [
                $target
            ]);
        });
    }
    /**
   * Closes the sub-menu defined by `$target`. All sub-menus inside the target will be closed as well.
   * @param {jQuery} $target - Sub-menu to close.
   * @fires AccordionMenu#up
   */ up($target) {
        const $submenus = $target.find('[data-submenu]');
        const $allmenus = $target.add($submenus);
        $submenus.slideUp(0);
        $allmenus.removeClass('is-active').attr('aria-hidden', true);
        if (this.options.submenuToggle) $allmenus.prev('.submenu-toggle').attr('aria-expanded', false);
        else $allmenus.parent('.is-accordion-submenu-parent').attr('aria-expanded', false);
        $target.slideUp(this.options.slideSpeed, ()=>{
            /**
       * Fires when the menu is done collapsing up.
       * @event AccordionMenu#up
       */ this.$element.trigger('up.zf.accordionMenu', [
                $target
            ]);
        });
    }
    /**
   * Destroys an instance of accordion menu.
   * @fires AccordionMenu#destroyed
   */ _destroy() {
        this.$element.find('[data-submenu]').slideDown(0).css('display', '');
        this.$element.find('a').off('click.zf.accordionMenu');
        this.$element.find('[data-is-parent-link]').detach();
        if (this.options.submenuToggle) {
            this.$element.find('.has-submenu-toggle').removeClass('has-submenu-toggle');
            this.$element.find('.submenu-toggle').remove();
        }
        (0, $7pq6k.Nest).Burn(this.$element, 'accordion');
    }
}
$e4f73f756a153fc9$export$6abe07ec29339e67.defaults = {
    /**
   * Adds the parent link to the submenu.
   * @option
   * @type {boolean}
   * @default false
   */ parentLink: false,
    /**
   * Amount of time to animate the opening of a submenu in ms.
   * @option
   * @type {number}
   * @default 250
   */ slideSpeed: 250,
    /**
   * Adds a separate submenu toggle button. This allows the parent item to have a link.
   * @option
   * @example true
   */ submenuToggle: false,
    /**
   * The text used for the submenu toggle if enabled. This is used for screen readers only.
   * @option
   * @example true
   */ submenuToggleText: 'Toggle menu',
    /**
   * Allow the menu to have multiple open panes.
   * @option
   * @type {boolean}
   * @default true
   */ multiOpen: true
};

});
parcelRegister("7hXZi", function(module, exports) {

$parcel$export(module.exports, "Plugin", function () { return $54e8a739bf7d4d81$export$901cf72dabf2112a; });

var $5XiQP = parcelRequire("5XiQP");
// Abstract class for providing lifecycle hooks. Expect plugins to define AT LEAST
// {function} _setup (replaces previous constructor),
// {function} _destroy (replaces previous destroy)
class $54e8a739bf7d4d81$export$901cf72dabf2112a {
    constructor(element, options){
        this._setup(element, options);
        var pluginName = $54e8a739bf7d4d81$var$getPluginName(this);
        this.uuid = (0, $5XiQP.GetYoDigits)(6, pluginName);
        if (!this.$element.attr(`data-${pluginName}`)) this.$element.attr(`data-${pluginName}`, this.uuid);
        if (!this.$element.data('zfPlugin')) this.$element.data('zfPlugin', this);
        /**
     * Fires when the plugin has initialized.
     * @event Plugin#init
     */ this.$element.trigger(`init.zf.${pluginName}`);
    }
    destroy() {
        this._destroy();
        var pluginName = $54e8a739bf7d4d81$var$getPluginName(this);
        this.$element.removeAttr(`data-${pluginName}`).removeData('zfPlugin')/**
         * Fires when the plugin has been destroyed.
         * @event Plugin#destroyed
         */ .trigger(`destroyed.zf.${pluginName}`);
        for(var prop in this)if (this.hasOwnProperty(prop)) this[prop] = null; //clean up script to prep for garbage collection.
    }
}
// Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580
function $54e8a739bf7d4d81$var$hyphenate(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $54e8a739bf7d4d81$var$getPluginName(obj) {
    return $54e8a739bf7d4d81$var$hyphenate(obj.className);
}

});


parcelRegister("lbeA6", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", function () { return $f6b5ef9b474cd305$export$e44a253a59704894; });

var $cMmgH = parcelRequire("cMmgH");

var $7hXZi = parcelRequire("7hXZi");

var $5XiQP = parcelRequire("5XiQP");

var $kvWGb = parcelRequire("kvWGb");

var $7pq6k = parcelRequire("7pq6k");

var $1DEAP = parcelRequire("1DEAP");

var $aNFr7 = parcelRequire("aNFr7");
/**
 * DropdownMenu module.
 * @module foundation.dropdownMenu
 * @requires foundation.util.keyboard
 * @requires foundation.util.box
 * @requires foundation.util.nest
 * @requires foundation.util.touch
 */ class $f6b5ef9b474cd305$export$e44a253a59704894 extends (0, $7hXZi.Plugin) {
    /**
   * Creates a new instance of DropdownMenu.
   * @class
   * @name DropdownMenu
   * @fires DropdownMenu#init
   * @param {jQuery} element - jQuery object to make into a dropdown menu.
   * @param {Object} options - Overrides to the default plugin settings.
   */ _setup(element, options) {
        this.$element = element;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend({}, $f6b5ef9b474cd305$export$e44a253a59704894.defaults, this.$element.data(), options);
        this.className = 'DropdownMenu'; // ie9 back compat
        (0, $aNFr7.Touch).init((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))); // Touch init is idempotent, we just need to make sure it's initialied.
        this._init();
        (0, $kvWGb.Keyboard).register('DropdownMenu', {
            'ENTER': 'open',
            'SPACE': 'open',
            'ARROW_RIGHT': 'next',
            'ARROW_UP': 'up',
            'ARROW_DOWN': 'down',
            'ARROW_LEFT': 'previous',
            'ESCAPE': 'close'
        });
    }
    /**
   * Initializes the plugin, and calls _prepareMenu
   * @private
   * @function
   */ _init() {
        (0, $7pq6k.Nest).Feather(this.$element, 'dropdown');
        var subs = this.$element.find('li.is-dropdown-submenu-parent');
        this.$element.children('.is-dropdown-submenu-parent').children('.is-dropdown-submenu').addClass('first-sub');
        this.$menuItems = this.$element.find('li[role="none"]');
        this.$tabs = this.$element.children('li[role="none"]');
        this.$tabs.find('ul.is-dropdown-submenu').addClass(this.options.verticalClass);
        if (this.options.alignment === 'auto') {
            if (this.$element.hasClass(this.options.rightClass) || (0, $5XiQP.rtl)() || this.$element.parents('.top-bar-right').is('*')) {
                this.options.alignment = 'right';
                subs.addClass('opens-left');
            } else {
                this.options.alignment = 'left';
                subs.addClass('opens-right');
            }
        } else if (this.options.alignment === 'right') subs.addClass('opens-left');
        else subs.addClass('opens-right');
        this.changed = false;
        this._events();
    }
    _isVertical() {
        return this.$tabs.css('display') === 'block' || this.$element.css('flex-direction') === 'column';
    }
    _isRtl() {
        return this.$element.hasClass('align-right') || (0, $5XiQP.rtl)() && !this.$element.hasClass('align-left');
    }
    /**
   * Adds event listeners to elements within the menu
   * @private
   * @function
   */ _events() {
        var _this = this, hasTouch = 'ontouchstart' in window || typeof window.ontouchstart !== 'undefined', parClass = 'is-dropdown-submenu-parent';
        // used for onClick and in the keyboard handlers
        var handleClickFn = function(e) {
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(e.target).parentsUntil('ul', `.${parClass}`), hasSub = $elem.hasClass(parClass), hasClicked = $elem.attr('data-is-click') === 'true', $sub = $elem.children('.is-dropdown-submenu');
            if (hasSub) {
                if (hasClicked) {
                    if (!_this.options.closeOnClick || !_this.options.clickOpen && !hasTouch || _this.options.forceFollow && hasTouch) return;
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    _this._hide($elem);
                } else {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    _this._show($sub);
                    $elem.add($elem.parentsUntil(_this.$element, `.${parClass}`)).attr('data-is-click', true);
                }
            }
        };
        if (this.options.clickOpen || hasTouch) this.$menuItems.on('click.zf.dropdownMenu touchstart.zf.dropdownMenu', handleClickFn);
        // Handle Leaf element Clicks
        if (_this.options.closeOnClickInside) this.$menuItems.on('click.zf.dropdownMenu', function() {
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), hasSub = $elem.hasClass(parClass);
            if (!hasSub) _this._hide();
        });
        if (hasTouch && this.options.disableHoverOnTouch) this.options.disableHover = true;
        if (!this.options.disableHover) this.$menuItems.on('mouseenter.zf.dropdownMenu', function() {
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), hasSub = $elem.hasClass(parClass);
            if (hasSub) {
                clearTimeout($elem.data('_delay'));
                $elem.data('_delay', setTimeout(function() {
                    _this._show($elem.children('.is-dropdown-submenu'));
                }, _this.options.hoverDelay));
            }
        }).on('mouseleave.zf.dropdownMenu', (0, $5XiQP.ignoreMousedisappear)(function() {
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this), hasSub = $elem.hasClass(parClass);
            if (hasSub && _this.options.autoclose) {
                if ($elem.attr('data-is-click') === 'true' && _this.options.clickOpen) return false;
                clearTimeout($elem.data('_delay'));
                $elem.data('_delay', setTimeout(function() {
                    _this._hide($elem);
                }, _this.options.closingTime));
            }
        }));
        this.$menuItems.on('keydown.zf.dropdownMenu', function(e) {
            var $element = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(e.target).parentsUntil('ul', '[role="none"]'), isTab = _this.$tabs.index($element) > -1, $elements = isTab ? _this.$tabs : $element.siblings('li').add($element), $prevElement, $nextElement;
            $elements.each(function(i) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this).is($element)) {
                    $prevElement = $elements.eq(i - 1);
                    $nextElement = $elements.eq(i + 1);
                    return;
                }
            });
            var nextSibling = function() {
                $nextElement.children('a:first').focus();
                e.preventDefault();
            }, prevSibling = function() {
                $prevElement.children('a:first').focus();
                e.preventDefault();
            }, openSub = function() {
                var $sub = $element.children('ul.is-dropdown-submenu');
                if ($sub.length) {
                    _this._show($sub);
                    $element.find('li > a:first').focus();
                    e.preventDefault();
                } else return;
            }, closeSub = function() {
                //if ($element.is(':first-child')) {
                var close = $element.parent('ul').parent('li');
                close.children('a:first').focus();
                _this._hide(close);
                e.preventDefault();
            //}
            };
            var functions = {
                open: openSub,
                close: function() {
                    _this._hide(_this.$element);
                    _this.$menuItems.eq(0).children('a').focus(); // focus to first element
                    e.preventDefault();
                }
            };
            if (isTab) {
                if (_this._isVertical()) {
                    if (_this._isRtl()) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                        down: nextSibling,
                        up: prevSibling,
                        next: closeSub,
                        previous: openSub
                    });
                    else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                        down: nextSibling,
                        up: prevSibling,
                        next: openSub,
                        previous: closeSub
                    });
                } else if (_this._isRtl()) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                    next: prevSibling,
                    previous: nextSibling,
                    down: openSub,
                    up: closeSub
                });
                else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                    next: nextSibling,
                    previous: prevSibling,
                    down: openSub,
                    up: closeSub
                });
            } else if (_this._isRtl()) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                next: closeSub,
                previous: openSub,
                down: nextSibling,
                up: prevSibling
            });
            else (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend(functions, {
                next: openSub,
                previous: closeSub,
                down: nextSibling,
                up: prevSibling
            });
            (0, $kvWGb.Keyboard).handleKey(e, 'DropdownMenu', functions);
        });
    }
    /**
   * Adds an event handler to the body to close any dropdowns on a click.
   * @function
   * @private
   */ _addBodyHandler() {
        const $body = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document.body);
        this._removeBodyHandler();
        $body.on('click.zf.dropdownMenu tap.zf.dropdownMenu', (e)=>{
            var isItself = !!(0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(e.target).closest(this.$element).length;
            if (isItself) return;
            this._hide();
            this._removeBodyHandler();
        });
    }
    /**
   * Remove the body event handler. See `_addBodyHandler`.
   * @function
   * @private
   */ _removeBodyHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document.body).off('click.zf.dropdownMenu tap.zf.dropdownMenu');
    }
    /**
   * Opens a dropdown pane, and checks for collisions first.
   * @param {jQuery} $sub - ul element that is a submenu to show
   * @function
   * @private
   * @fires DropdownMenu#show
   */ _show($sub) {
        var idx = this.$tabs.index(this.$tabs.filter(function(i, el) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(el).find($sub).length > 0;
        }));
        var $sibs = $sub.parent('li.is-dropdown-submenu-parent').siblings('li.is-dropdown-submenu-parent');
        this._hide($sibs, idx);
        $sub.css('visibility', 'hidden').addClass('js-dropdown-active').parent('li.is-dropdown-submenu-parent').addClass('is-active');
        var clear = (0, $1DEAP.Box).ImNotTouchingYou($sub, null, true);
        if (!clear) {
            var oldClass = this.options.alignment === 'left' ? '-right' : '-left', $parentLi = $sub.parent('.is-dropdown-submenu-parent');
            $parentLi.removeClass(`opens${oldClass}`).addClass(`opens-${this.options.alignment}`);
            clear = (0, $1DEAP.Box).ImNotTouchingYou($sub, null, true);
            if (!clear) $parentLi.removeClass(`opens-${this.options.alignment}`).addClass('opens-inner');
            this.changed = true;
        }
        $sub.css('visibility', '');
        if (this.options.closeOnClick) this._addBodyHandler();
        /**
     * Fires when the new dropdown pane is visible.
     * @event DropdownMenu#show
     */ this.$element.trigger('show.zf.dropdownMenu', [
            $sub
        ]);
    }
    /**
   * Hides a single, currently open dropdown pane, if passed a parameter, otherwise, hides everything.
   * @function
   * @param {jQuery} $elem - element with a submenu to hide
   * @param {Number} idx - index of the $tabs collection to hide
   * @fires DropdownMenu#hide
   * @private
   */ _hide($elem, idx) {
        var $toClose;
        if ($elem && $elem.length) $toClose = $elem;
        else if (typeof idx !== 'undefined') $toClose = this.$tabs.not(function(i) {
            return i === idx;
        });
        else $toClose = this.$element;
        var somethingToClose = $toClose.hasClass('is-active') || $toClose.find('.is-active').length > 0;
        if (somethingToClose) {
            var $activeItem = $toClose.find('li.is-active');
            $activeItem.add($toClose).attr({
                'data-is-click': false
            }).removeClass('is-active');
            $toClose.find('ul.js-dropdown-active').removeClass('js-dropdown-active');
            if (this.changed || $toClose.find('opens-inner').length) {
                var oldClass = this.options.alignment === 'left' ? 'right' : 'left';
                $toClose.find('li.is-dropdown-submenu-parent').add($toClose).removeClass(`opens-inner opens-${this.options.alignment}`).addClass(`opens-${oldClass}`);
                this.changed = false;
            }
            clearTimeout($activeItem.data('_delay'));
            this._removeBodyHandler();
            /**
       * Fires when the open menus are closed.
       * @event DropdownMenu#hide
       */ this.$element.trigger('hide.zf.dropdownMenu', [
                $toClose
            ]);
        }
    }
    /**
   * Destroys the plugin.
   * @function
   */ _destroy() {
        this.$menuItems.off('.zf.dropdownMenu').removeAttr('data-is-click').removeClass('is-right-arrow is-left-arrow is-down-arrow opens-right opens-left opens-inner');
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document.body).off('.zf.dropdownMenu');
        (0, $7pq6k.Nest).Burn(this.$element, 'dropdown');
    }
}
/**
 * Default settings for plugin
 */ $f6b5ef9b474cd305$export$e44a253a59704894.defaults = {
    /**
   * Disallows hover events from opening submenus
   * @option
   * @type {boolean}
   * @default false
   */ disableHover: false,
    /**
   * Disallows hover on touch devices
   * @option
   * @type {boolean}
   * @default true
   */ disableHoverOnTouch: true,
    /**
   * Allow a submenu to automatically close on a mouseleave event, if not clicked open.
   * @option
   * @type {boolean}
   * @default true
   */ autoclose: true,
    /**
   * Amount of time to delay opening a submenu on hover event.
   * @option
   * @type {number}
   * @default 50
   */ hoverDelay: 50,
    /**
   * Allow a submenu to open/remain open on parent click event. Allows cursor to move away from menu.
   * @option
   * @type {boolean}
   * @default false
   */ clickOpen: false,
    /**
   * Amount of time to delay closing a submenu on a mouseleave event.
   * @option
   * @type {number}
   * @default 500
   */ closingTime: 500,
    /**
   * Position of the menu relative to what direction the submenus should open. Handled by JS. Can be `'auto'`, `'left'` or `'right'`.
   * @option
   * @type {string}
   * @default 'auto'
   */ alignment: 'auto',
    /**
   * Allow clicks on the body to close any open submenus.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClick: true,
    /**
   * Allow clicks on leaf anchor links to close any open submenus.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClickInside: true,
    /**
   * Class applied to vertical oriented menus, Foundation default is `vertical`. Update this if using your own class.
   * @option
   * @type {string}
   * @default 'vertical'
   */ verticalClass: 'vertical',
    /**
   * Class applied to right-side oriented menus, Foundation default is `align-right`. Update this if using your own class.
   * @option
   * @type {string}
   * @default 'align-right'
   */ rightClass: 'align-right',
    /**
   * Boolean to force overide the clicking of links to perform default action, on second touch event for mobile.
   * @option
   * @type {boolean}
   * @default true
   */ forceFollow: true
};

});

parcelRegister("lvQTI", function(module, exports) {

$parcel$export(module.exports, "OffCanvas", function () { return $fa958695c06fac04$export$644db29b3dffde4c; });

var $cMmgH = parcelRequire("cMmgH");

var $7hXZi = parcelRequire("7hXZi");

var $5XiQP = parcelRequire("5XiQP");

var $kvWGb = parcelRequire("kvWGb");

var $cvxXx = parcelRequire("cvxXx");

var $5EyIV = parcelRequire("5EyIV");
/**
 * OffCanvas module.
 * @module foundation.offCanvas
 * @requires foundation.util.keyboard
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.triggers
 */ class $fa958695c06fac04$export$644db29b3dffde4c extends (0, $7hXZi.Plugin) {
    /**
   * Creates a new instance of an off-canvas wrapper.
   * @class
   * @name OffCanvas
   * @fires OffCanvas#init
   * @param {Object} element - jQuery object to initialize.
   * @param {Object} options - Overrides to the default plugin settings.
   */ _setup(element, options) {
        this.className = 'OffCanvas'; // ie9 back compat
        this.$element = element;
        this.options = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))).extend({}, $fa958695c06fac04$export$644db29b3dffde4c.defaults, this.$element.data(), options);
        this.contentClasses = {
            base: [],
            reveal: []
        };
        this.$lastTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))();
        this.$triggers = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))();
        this.position = 'left';
        this.$content = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))();
        this.nested = !!this.options.nested;
        this.$sticky = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))();
        this.isInCanvas = false;
        // Defines the CSS transition/position classes of the off-canvas content container.
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))([
            'push',
            'overlap'
        ]).each((index, val)=>{
            this.contentClasses.base.push('has-transition-' + val);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))([
            'left',
            'right',
            'top',
            'bottom'
        ]).each((index, val)=>{
            this.contentClasses.base.push('has-position-' + val);
            this.contentClasses.reveal.push('has-reveal-' + val);
        });
        // Triggers init is idempotent, just need to make sure it is initialized
        (0, $5EyIV.Triggers).init((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))));
        (0, $cvxXx.MediaQuery)._init();
        this._init();
        this._events();
        (0, $kvWGb.Keyboard).register('OffCanvas', {
            'ESCAPE': 'close'
        });
    }
    /**
   * Initializes the off-canvas wrapper by adding the exit overlay (if needed).
   * @function
   * @private
   */ _init() {
        var id = this.$element.attr('id');
        this.$element.attr('aria-hidden', 'true');
        // Find off-canvas content, either by ID (if specified), by siblings or by closest selector (fallback)
        if (this.options.contentId) this.$content = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('#' + this.options.contentId);
        else if (this.$element.siblings('[data-off-canvas-content]').length) this.$content = this.$element.siblings('[data-off-canvas-content]').first();
        else this.$content = this.$element.closest('[data-off-canvas-content]').first();
        if (!this.options.contentId) // Assume that the off-canvas element is nested if it isn't a sibling of the content
        this.nested = this.$element.siblings('[data-off-canvas-content]').length === 0;
        else if (this.options.contentId && this.options.nested === null) // Warning if using content ID without setting the nested option
        // Once the element is nested it is required to work properly in this case
        console.warn('Remember to use the nested option if using the content ID option!');
        if (this.nested === true) {
            // Force transition overlap if nested
            this.options.transition = 'overlap';
            // Remove appropriate classes if already assigned in markup
            this.$element.removeClass('is-transition-push');
        }
        this.$element.addClass(`is-transition-${this.options.transition} is-closed`);
        // Find triggers that affect this element and add aria-expanded to them
        this.$triggers = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-expanded', 'false').attr('aria-controls', id);
        // Get position by checking for related CSS class
        this.position = this.$element.is('.position-left, .position-top, .position-right, .position-bottom') ? this.$element.attr('class').match(/position\-(left|top|right|bottom)/)[1] : this.position;
        // Add an overlay over the content if necessary
        if (this.options.contentOverlay === true) {
            var overlay = document.createElement('div');
            var overlayPosition = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this.$element).css("position") === 'fixed' ? 'is-overlay-fixed' : 'is-overlay-absolute';
            overlay.setAttribute('class', 'js-off-canvas-overlay ' + overlayPosition);
            this.$overlay = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(overlay);
            if (overlayPosition === 'is-overlay-fixed') (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(this.$overlay).insertAfter(this.$element);
            else this.$content.append(this.$overlay);
        }
        // Get the revealOn option from the class.
        var revealOnRegExp = new RegExp((0, $5XiQP.RegExpEscape)(this.options.revealClass) + '([^\\s]+)', 'g');
        var revealOnClass = revealOnRegExp.exec(this.$element[0].className);
        if (revealOnClass) {
            this.options.isRevealed = true;
            this.options.revealOn = this.options.revealOn || revealOnClass[1];
        }
        // Ensure the `reveal-on-*` class is set.
        if (this.options.isRevealed === true && this.options.revealOn) {
            this.$element.first().addClass(`${this.options.revealClass}${this.options.revealOn}`);
            this._setMQChecker();
        }
        if (this.options.transitionTime) this.$element.css('transition-duration', this.options.transitionTime);
        // Find fixed elements that should stay fixed while off-canvas is opened
        this.$sticky = this.$content.find('[data-off-canvas-sticky]');
        if (this.$sticky.length > 0 && this.options.transition === 'push') // If there's at least one match force contentScroll:false because the absolute top value doesn't get recalculated on scroll
        // Limit to push transition since there's no transform scope for overlap
        this.options.contentScroll = false;
        let inCanvasFor = this.$element.attr('class').match(/\bin-canvas-for-(\w+)/);
        if (inCanvasFor && inCanvasFor.length === 2) // Set `inCanvasOn` option if found in-canvas-for-[BREAKPONT] CSS class
        this.options.inCanvasOn = inCanvasFor[1];
        else if (this.options.inCanvasOn) // Ensure the CSS class is set
        this.$element.addClass(`in-canvas-for-${this.options.inCanvasOn}`);
        if (this.options.inCanvasOn) this._checkInCanvas();
        // Initally remove all transition/position CSS classes from off-canvas content container.
        this._removeContentClasses();
    }
    /**
   * Adds event handlers to the off-canvas wrapper and the exit overlay.
   * @function
   * @private
   */ _events() {
        this.$element.off('.zf.trigger .zf.offCanvas').on({
            'open.zf.trigger': this.open.bind(this),
            'close.zf.trigger': this.close.bind(this),
            'toggle.zf.trigger': this.toggle.bind(this),
            'keydown.zf.offCanvas': this._handleKeyboard.bind(this)
        });
        if (this.options.closeOnClick === true) {
            var $target = this.options.contentOverlay ? this.$overlay : this.$content;
            $target.on({
                'click.zf.offCanvas': this.close.bind(this)
            });
        }
        if (this.options.inCanvasOn) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).on('changed.zf.mediaquery', ()=>{
            this._checkInCanvas();
        });
    }
    /**
   * Applies event listener for elements that will reveal at certain breakpoints.
   * @private
   */ _setMQChecker() {
        var _this = this;
        this.onLoadListener = (0, $5XiQP.onLoad)((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window), function() {
            if ((0, $cvxXx.MediaQuery).atLeast(_this.options.revealOn)) _this.reveal(true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).on('changed.zf.mediaquery', function() {
            if ((0, $cvxXx.MediaQuery).atLeast(_this.options.revealOn)) _this.reveal(true);
            else _this.reveal(false);
        });
    }
    /**
   * Checks if InCanvas on current breakpoint and adjust off-canvas accordingly
   * @private
   */ _checkInCanvas() {
        this.isInCanvas = (0, $cvxXx.MediaQuery).atLeast(this.options.inCanvasOn);
        if (this.isInCanvas === true) this.close();
    }
    /**
   * Removes the CSS transition/position classes of the off-canvas content container.
   * Removing the classes is important when another off-canvas gets opened that uses the same content container.
   * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
   * @private
   */ _removeContentClasses(hasReveal) {
        if (typeof hasReveal !== 'boolean') this.$content.removeClass(this.contentClasses.base.join(' '));
        else if (hasReveal === false) this.$content.removeClass(`has-reveal-${this.position}`);
    }
    /**
   * Adds the CSS transition/position classes of the off-canvas content container, based on the opening off-canvas element.
   * Beforehand any transition/position class gets removed.
   * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
   * @private
   */ _addContentClasses(hasReveal) {
        this._removeContentClasses(hasReveal);
        if (typeof hasReveal !== 'boolean') this.$content.addClass(`has-transition-${this.options.transition} has-position-${this.position}`);
        else if (hasReveal === true) this.$content.addClass(`has-reveal-${this.position}`);
    }
    /**
   * Preserves the fixed behavior of sticky elements on opening an off-canvas with push transition.
   * Since the off-canvas container has got a transform scope in such a case, it is done by calculating position absolute values.
   * @private
   */ _fixStickyElements() {
        this.$sticky.each((_, el)=>{
            const $el = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(el);
            // If sticky element is currently fixed, adjust its top value to match absolute position due to transform scope
            // Limit to push transition because postion:fixed works without problems for overlap (no transform scope)
            if ($el.css('position') === 'fixed') {
                // Save current inline styling to restore it if undoing the absolute fixing
                let topVal = parseInt($el.css('top'), 10);
                $el.data('offCanvasSticky', {
                    top: topVal
                });
                let absoluteTopVal = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(document).scrollTop() + topVal;
                $el.css({
                    top: `${absoluteTopVal}px`,
                    width: '100%',
                    transition: 'none'
                });
            }
        });
    }
    /**
   * Restores the original fixed styling of sticky elements after having closed an off-canvas that got pseudo fixed beforehand.
   * This reverts the changes of _fixStickyElements()
   * @private
   */ _unfixStickyElements() {
        this.$sticky.each((_, el)=>{
            const $el = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(el);
            let stickyData = $el.data('offCanvasSticky');
            // If sticky element has got data object with prior values (meaning it was originally fixed) restore these values once off-canvas is closed
            if (typeof stickyData === 'object') {
                $el.css({
                    top: `${stickyData.top}px`,
                    width: '',
                    transition: ''
                });
                $el.data('offCanvasSticky', '');
            }
        });
    }
    /**
   * Handles the revealing/hiding the off-canvas at breakpoints, not the same as open.
   * @param {Boolean} isRevealed - true if element should be revealed.
   * @function
   */ reveal(isRevealed) {
        if (isRevealed) {
            this.close();
            this.isRevealed = true;
            this.$element.attr('aria-hidden', 'false');
            this.$element.off('open.zf.trigger toggle.zf.trigger');
            this.$element.removeClass('is-closed');
        } else {
            this.isRevealed = false;
            this.$element.attr('aria-hidden', 'true');
            this.$element.off('open.zf.trigger toggle.zf.trigger').on({
                'open.zf.trigger': this.open.bind(this),
                'toggle.zf.trigger': this.toggle.bind(this)
            });
            this.$element.addClass('is-closed');
        }
        this._addContentClasses(isRevealed);
    }
    /**
   * Stops scrolling of the body when OffCanvas is open on mobile Safari and other troublesome browsers.
   * @function
   * @private
   */ _stopScrolling() {
        return false;
    }
    /**
   * Save current finger y-position
   * @param event
   * @private
   */ _recordScrollable(event) {
        const elem = this;
        elem.lastY = event.touches[0].pageY;
    }
    /**
   * Prevent further scrolling when it hits the edges
   * @param event
   * @private
   */ _preventDefaultAtEdges(event) {
        const elem = this;
        const _this = event.data;
        const delta = elem.lastY - event.touches[0].pageY;
        elem.lastY = event.touches[0].pageY;
        if (!_this._canScroll(delta, elem)) event.preventDefault();
    }
    /**
   * Handle continuous scrolling of scrollbox
   * Don't bubble up to _preventDefaultAtEdges
   * @param event
   * @private
   */ _scrollboxTouchMoved(event) {
        const elem = this;
        const _this = event.data;
        const parent = elem.closest('[data-off-canvas], [data-off-canvas-scrollbox-outer]');
        const delta = elem.lastY - event.touches[0].pageY;
        parent.lastY = elem.lastY = event.touches[0].pageY;
        event.stopPropagation();
        if (!_this._canScroll(delta, elem)) {
            if (!_this._canScroll(delta, parent)) event.preventDefault();
            else parent.scrollTop += delta;
        }
    }
    /**
   * Detect possibility of scrolling
   * @param delta
   * @param elem
   * @returns boolean
   * @private
   */ _canScroll(delta, elem) {
        const up = delta < 0;
        const down = delta > 0;
        const allowUp = elem.scrollTop > 0;
        const allowDown = elem.scrollTop < elem.scrollHeight - elem.clientHeight;
        return up && allowUp || down && allowDown;
    }
    /**
   * Opens the off-canvas menu.
   * @function
   * @param {Object} event - Event object passed from listener.
   * @param {jQuery} trigger - element that triggered the off-canvas to open.
   * @fires OffCanvas#opened
   * @todo also trigger 'open' event?
   */ open(event, trigger) {
        if (this.$element.hasClass('is-open') || this.isRevealed || this.isInCanvas) return;
        var _this = this;
        if (trigger) this.$lastTrigger = trigger;
        if (this.options.forceTo === 'top') window.scrollTo(0, 0);
        else if (this.options.forceTo === 'bottom') window.scrollTo(0, document.body.scrollHeight);
        if (this.options.transitionTime && this.options.transition !== 'overlap') this.$element.siblings('[data-off-canvas-content]').css('transition-duration', this.options.transitionTime);
        else this.$element.siblings('[data-off-canvas-content]').css('transition-duration', '');
        this.$element.addClass('is-open').removeClass('is-closed');
        this.$triggers.attr('aria-expanded', 'true');
        this.$element.attr('aria-hidden', 'false');
        this.$content.addClass('is-open-' + this.position);
        // If `contentScroll` is set to false, add class and disable scrolling on touch devices.
        if (this.options.contentScroll === false) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('body').addClass('is-off-canvas-open').on('touchmove', this._stopScrolling);
            this.$element.on('touchstart', this._recordScrollable);
            this.$element.on('touchmove', this, this._preventDefaultAtEdges);
            this.$element.on('touchstart', '[data-off-canvas-scrollbox]', this._recordScrollable);
            this.$element.on('touchmove', '[data-off-canvas-scrollbox]', this, this._scrollboxTouchMoved);
        }
        if (this.options.contentOverlay === true) this.$overlay.addClass('is-visible');
        if (this.options.closeOnClick === true && this.options.contentOverlay === true) this.$overlay.addClass('is-closable');
        if (this.options.autoFocus === true) this.$element.one((0, $5XiQP.transitionend)(this.$element), function() {
            if (!_this.$element.hasClass('is-open')) return; // exit if prematurely closed
            var canvasFocus = _this.$element.find('[data-autofocus]');
            if (canvasFocus.length) canvasFocus.eq(0).focus();
            else _this.$element.find('a, button').eq(0).focus();
        });
        if (this.options.trapFocus === true) {
            this.$content.attr('tabindex', '-1');
            (0, $kvWGb.Keyboard).trapFocus(this.$element);
        }
        if (this.options.transition === 'push') this._fixStickyElements();
        this._addContentClasses();
        /**
     * Fires when the off-canvas menu opens.
     * @event OffCanvas#opened
     */ this.$element.trigger('opened.zf.offCanvas');
        /**
     * Fires when the off-canvas menu open transition is done.
     * @event OffCanvas#openedEnd
     */ this.$element.one((0, $5XiQP.transitionend)(this.$element), ()=>{
            this.$element.trigger('openedEnd.zf.offCanvas');
        });
    }
    /**
   * Closes the off-canvas menu.
   * @function
   * @param {Function} cb - optional cb to fire after closure.
   * @fires OffCanvas#close
   * @fires OffCanvas#closed
   */ close() {
        if (!this.$element.hasClass('is-open') || this.isRevealed) return;
        /**
     * Fires when the off-canvas menu closes.
     * @event OffCanvas#close
     */ this.$element.trigger('close.zf.offCanvas');
        this.$element.removeClass('is-open');
        this.$element.attr('aria-hidden', 'true');
        this.$content.removeClass('is-open-left is-open-top is-open-right is-open-bottom');
        if (this.options.contentOverlay === true) this.$overlay.removeClass('is-visible');
        if (this.options.closeOnClick === true && this.options.contentOverlay === true) this.$overlay.removeClass('is-closable');
        this.$triggers.attr('aria-expanded', 'false');
        // Listen to transitionEnd: add class, re-enable scrolling and release focus when done.
        this.$element.one((0, $5XiQP.transitionend)(this.$element), ()=>{
            this.$element.addClass('is-closed');
            this._removeContentClasses();
            if (this.options.transition === 'push') this._unfixStickyElements();
            // If `contentScroll` is set to false, remove class and re-enable scrolling on touch devices.
            if (this.options.contentScroll === false) {
                (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))('body').removeClass('is-off-canvas-open').off('touchmove', this._stopScrolling);
                this.$element.off('touchstart', this._recordScrollable);
                this.$element.off('touchmove', this._preventDefaultAtEdges);
                this.$element.off('touchstart', '[data-off-canvas-scrollbox]', this._recordScrollable);
                this.$element.off('touchmove', '[data-off-canvas-scrollbox]', this._scrollboxTouchMoved);
            }
            if (this.options.trapFocus === true) {
                this.$content.removeAttr('tabindex');
                (0, $kvWGb.Keyboard).releaseFocus(this.$element);
            }
            /**
       * Fires when the off-canvas menu close transition is done.
       * @event OffCanvas#closed
       */ this.$element.trigger('closed.zf.offCanvas');
        });
    }
    /**
   * Toggles the off-canvas menu open or closed.
   * @function
   * @param {Object} event - Event object passed from listener.
   * @param {jQuery} trigger - element that triggered the off-canvas to open.
   */ toggle(event, trigger) {
        if (this.$element.hasClass('is-open')) this.close(event, trigger);
        else this.open(event, trigger);
    }
    /**
   * Handles keyboard input when detected. When the escape key is pressed, the off-canvas menu closes, and focus is restored to the element that opened the menu.
   * @function
   * @private
   */ _handleKeyboard(e) {
        (0, $kvWGb.Keyboard).handleKey(e, 'OffCanvas', {
            close: ()=>{
                this.close();
                this.$lastTrigger.focus();
                return true;
            },
            handled: ()=>{
                e.preventDefault();
            }
        });
    }
    /**
   * Destroys the OffCanvas plugin.
   * @function
   */ _destroy() {
        this.close();
        this.$element.off('.zf.trigger .zf.offCanvas');
        this.$overlay.off('.zf.offCanvas');
        if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)))(window).off(this.onLoadListener);
    }
}
$fa958695c06fac04$export$644db29b3dffde4c.defaults = {
    /**
   * Allow the user to click outside of the menu to close it.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClick: true,
    /**
   * Adds an overlay on top of `[data-off-canvas-content]`.
   * @option
   * @type {boolean}
   * @default true
   */ contentOverlay: true,
    /**
   * Target an off-canvas content container by ID that may be placed anywhere. If null the closest content container will be taken.
   * @option
   * @type {?string}
   * @default null
   */ contentId: null,
    /**
   * Define the off-canvas element is nested in an off-canvas content. This is required when using the contentId option for a nested element.
   * @option
   * @type {boolean}
   * @default null
   */ nested: null,
    /**
   * Enable/disable scrolling of the main content when an off canvas panel is open.
   * @option
   * @type {boolean}
   * @default true
   */ contentScroll: true,
    /**
   * Amount of time the open and close transition requires, including the appropriate milliseconds (`ms`) or seconds (`s`) unit (e.g. `500ms`, `.75s`) If none selected, pulls from body style.
   * @option
   * @type {string}
   * @default null
   */ transitionTime: null,
    /**
   * Type of transition for the OffCanvas menu. Options are 'push', 'detached' or 'slide'.
   * @option
   * @type {string}
   * @default push
   */ transition: 'push',
    /**
   * Force the page to scroll to top or bottom on open.
   * @option
   * @type {?string}
   * @default null
   */ forceTo: null,
    /**
   * Allow the OffCanvas to remain open for certain breakpoints.
   * @option
   * @type {boolean}
   * @default false
   */ isRevealed: false,
    /**
   * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
   * @option
   * @type {?string}
   * @default null
   */ revealOn: null,
    /**
   * Breakpoint at which the off-canvas gets moved into canvas content and acts as regular page element.
   * @option
   * @type {?string}
   * @default null
   */ inCanvasOn: null,
    /**
   * Force focus to the offcanvas on open. If true, will focus the opening trigger on close.
   * @option
   * @type {boolean}
   * @default true
   */ autoFocus: true,
    /**
   * Class used to force an OffCanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
   * @option
   * @type {string}
   * @default reveal-for-
   * @todo improve the regex testing for this.
   */ revealClass: 'reveal-for-',
    /**
   * Triggers optional focus trapping when opening an OffCanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
   * @option
   * @type {boolean}
   * @default false
   */ trapFocus: false
};

});


var $cMmgH = parcelRequire("cMmgH");

var $4PYAy = parcelRequire("4PYAy");

var $1DEAP = parcelRequire("1DEAP");

var $kvWGb = parcelRequire("kvWGb");

var $cvxXx = parcelRequire("cvxXx");

var $7pq6k = parcelRequire("7pq6k");
parcelRequire("aNFr7");

var $5EyIV = parcelRequire("5EyIV");

var $jEMkX = parcelRequire("jEMkX");

var $lbeA6 = parcelRequire("lbeA6");

var $lvQTI = parcelRequire("lvQTI");

window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)));
window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($cMmgH)));
// Configure touch events as passive (except when noPreventDefault is specified)
jQuery.event.special.touchstart = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchstart", handle, {
            passive: !ns.includes("noPreventDefault")
        });
    }
};
jQuery.event.special.touchmove = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchmove", handle, {
            passive: !ns.includes("noPreventDefault")
        });
    }
};
jQuery.event.special.touchend = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchend", handle, {
            passive: !ns.includes("noPreventDefault")
        });
    }
};
jQuery.event.special.wheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("wheel", handle, {
            passive: true
        });
    }
};
jQuery.event.special.mousewheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("mousewheel", handle, {
            passive: true
        });
    }
};
// Click events should NOT be passive to allow preventDefault
jQuery.event.special.click = {
    setup: function(_, ns, handle) {
        this.addEventListener("click", handle, {
            passive: false
        });
    }
};
var $14aa168469b2616d$exports = {};
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */ (function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments);
    }
    var q = Date.now || function() {
        return +new Date;
    };
    function ca(a, b) {
        this.a = a;
        this.o = b || a;
        this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c) for(var e in c)c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b;
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild);
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for(var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1){
            for(var f = !1, g = 0; g < d.length; g += 1)if (b[e] === d[g]) {
                f = !0;
                break;
            }
            f || d.push(b[e]);
        }
        b = [];
        for(e = 0; e < d.length; e += 1){
            f = !1;
            for(g = 0; g < c.length; g += 1)if (d[e] === c[g]) {
                f = !0;
                break;
            }
            f || b.push(d[e]);
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
        for(var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)if (c[d] == b) return !0;
        return !1;
    }
    function ea(a) {
        return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
        function d() {
            m && e && f && (m(g), m = null);
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1, f = !0, g = null, m = c || null;
        da ? (b.onload = function() {
            e = !0;
            d();
        }, b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d();
        }) : setTimeout(function() {
            e = !0;
            d();
        }, 0);
        u(a, "head", b);
    }
    function A(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            }), g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
            };
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0, c && c(Error("Script load timeout")));
            }, d || 5E3);
            return f;
        }
        return null;
    }
    function B() {
        this.a = 0;
        this.c = null;
    }
    function C(a) {
        a.a++;
        return function() {
            a.a--;
            D(a);
        };
    }
    function E(a, b) {
        a.c = b;
        D(a);
    }
    function D(a) {
        0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
        this.a = a || "-";
    }
    F.prototype.c = function(a) {
        for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a);
    };
    function G(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
        return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
        var b = [];
        a = a.split(/,\s*/);
        for(var c = 0; c < a.length; c++){
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
        }
        return b.join(",");
    }
    function J(a) {
        return a.a + a.f;
    }
    function H(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b;
    }
    function ga(a) {
        var b = 4, c = "n", d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b;
    }
    function ha(a, b) {
        this.c = a;
        this.f = a.o.document.documentElement;
        this.h = b;
        this.a = new F("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes;
    }
    function ia(a) {
        a.g && w(a.f, [
            a.a.c("wf", "loading")
        ]);
        K(a, "loading");
    }
    function L(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active")), c = [], d = [
                a.a.c("wf", "loading")
            ];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d);
        }
        K(a, "inactive");
    }
    function K(a, b, c) {
        if (a.j && a.h[b]) {
            if (c) a.h[b](c.c, J(c));
            else a.h[b]();
        }
    }
    function ja() {
        this.c = {};
    }
    function ka(a, b, c) {
        var d = [], e;
        for(e in b)if (b.hasOwnProperty(e)) {
            var f = a.c[e];
            f && d.push(f(b[e], c));
        }
        return d;
    }
    function M(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f);
    }
    function N(a) {
        u(a.c, "body", a.a);
    }
    function O(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0;
    }
    P.prototype.start = function() {
        var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d, e) {
            function f() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(f, 25);
                }, function() {
                    e();
                });
            }
            f();
        }), e = null, f = new Promise(function(a, d) {
            e = setTimeout(d, b.f);
        });
        Promise.race([
            f,
            d
        ]).then(function() {
            e && (clearTimeout(e), e = null);
            b.g(b.a);
        }, function() {
            b.j(b.a);
        });
    };
    function Q(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.m = this.j = this.h = this.g = null;
        this.g = new M(this.c, this.s);
        this.h = new M(this.c, this.s);
        this.j = new M(this.c, this.s);
        this.m = new M(this.c, this.s);
        a = new G(this.a.c + ",serif", J(this.a));
        a = O(a);
        this.g.a.style.cssText = a;
        a = new G(this.a.c + ",sans-serif", J(this.a));
        a = O(a);
        this.h.a.style.cssText = a;
        a = new G("serif", J(this.a));
        a = O(a);
        this.j.a.style.cssText = a;
        a = new G("sans-serif", J(this.a));
        a = O(a);
        this.m.a.style.cssText = a;
        N(this.g);
        N(this.h);
        N(this.j);
        N(this.m);
    }
    var R = {
        D: "serif",
        C: "sans-serif"
    }, S = null;
    function T() {
        if (null === S) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
        }
        return S;
    }
    Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.m.a.offsetWidth;
        this.A = q();
        U(this);
    };
    function la(a, b, c) {
        for(var d in R)if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]]) return !0;
        return !1;
    }
    function U(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
        d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
        setTimeout(p(function() {
            U(this);
        }, a), 50);
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.m.a);
            b(this.a);
        }, a), 0);
    }
    function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.m = this.j = !1;
        this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [
            b.a.c("wf", a.c, J(a).toString(), "active")
        ], [
            b.a.c("wf", a.c, J(a).toString(), "loading"),
            b.a.c("wf", a.c, J(a).toString(), "inactive")
        ]);
        K(b, "fontactive", a);
        this.m = !0;
        na(this);
    };
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [
                b.a.c("wf", a.c, J(a).toString(), "loading")
            ];
            c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
            w(b.f, d, e);
        }
        K(b, "fontinactive", a);
        na(this);
    };
    function na(a) {
        0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [
            a.a.c("wf", "active")
        ], [
            a.a.c("wf", "loading"),
            a.a.c("wf", "inactive")
        ]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0;
    }
    oa.prototype.load = function(a) {
        this.c = new ca(this.j, a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null, m = d || null || {};
            if (0 === c.length && f) L(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, l = [];
                for(h = 0; h < c.length; h++){
                    var k = c[h], n = m[k.c], r = b.a, x = k;
                    r.g && w(r.f, [
                        r.a.c("wf", x.c, J(x).toString(), "loading")
                    ]);
                    K(r, "fontloading", x);
                    r = null;
                    if (null === X) {
                        if (window.FontFace) {
                            var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                            X = x ? 42 < parseInt(x[1], 10) : xa ? !1 : !0;
                        } else X = !1;
                    }
                    X ? r = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a, n);
                    l.push(r);
                }
                for(h = 0; h < l.length; h++)l[h].start();
            }
        }, 0);
    }
    function pa(a, b, c) {
        var d = [], e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
        a.h = d.length;
        b = 0;
        for(c = d.length; b < c; b++)d[b].load(function(b, d, c) {
            qa(a, f, b, d, c);
        });
    }
    function ra(a, b) {
        this.c = a;
        this.a = b;
    }
    ra.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c) for(var l = 0; l < c.length; l++){
                    var k = c[l].fontfamily;
                    void 0 != c[l].fontStyle && void 0 != c[l].fontWeight ? (h = c[l].fontStyle + c[l].fontWeight, e.push(new G(k, h))) : e.push(new G(k));
                }
                a(e);
            } else setTimeout(function() {
                b();
            }, 50);
        }
        var c = this, d = c.a.projectId, e = c.a.version;
        if (d) {
            var f = c.c.o;
            A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a;
                }, b());
            }).id = "__MonotypeAPIScript__" + d;
        } else a([]);
    };
    function sa(a, b) {
        this.c = a;
        this.a = b;
    }
    sa.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B;
        b = 0;
        for(c = d.length; b < c; b++)z(this.c, d[b], C(g));
        var m = [];
        b = 0;
        for(c = e.length; b < c; b++)if (d = e[b].split(":"), d[1]) for(var h = d[1].split(","), l = 0; l < h.length; l += 1)m.push(new G(d[0], h[l]));
        else m.push(new G(d[0]));
        E(g, function() {
            a(m, f);
        });
    };
    function ta(a, b) {
        a ? this.c = a : this.c = ua;
        this.a = [];
        this.f = [];
        this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
        for(var c = b.length, d = 0; d < c; d++){
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f));
        }
    }
    function wa(a) {
        if (0 == a.a.length) throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit=")) return a.c;
        for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b;
    }
    function ya(a) {
        this.f = a;
        this.a = [];
        this.c = {};
    }
    var za = {
        latin: "BESbswy",
        "latin-ext": "\u00e7\u00f6\u00fc\u011f\u015f",
        cyrillic: "\u0439\u044f\u0416",
        greek: "\u03b1\u03b2\u03a3",
        khmer: "\u1780\u1781\u1782",
        Hanuman: "\u1780\u1781\u1782"
    }, Aa = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }, Ba = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
        for(var b = a.f.length, c = 0; c < b; c++){
            var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = [
                "n4"
            ];
            if (2 <= d.length) {
                var g;
                var m = d[1];
                g = [];
                if (m) for(var m = m.split(","), h = m.length, l = 0; l < h; l++){
                    var k;
                    k = m[l];
                    if (k.match(/^[\w-]+$/)) {
                        var n = Ca.exec(k.toLowerCase());
                        if (null == n) k = "";
                        else {
                            k = n[2];
                            k = null == k || "" == k ? "n" : Ba[k];
                            n = n[1];
                            if (null == n || "" == n) n = "4";
                            else var r = Aa[n], n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                            k = [
                                k,
                                n
                            ].join("");
                        }
                    } else k = "";
                    k && g.push(k);
                }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
            }
            a.c[e] || (d = za[e]) && (a.c[e] = d);
            for(d = 0; d < f.length; d += 1)a.a.push(new G(e, f[d]));
        }
    }
    function Ea(a, b) {
        this.c = a;
        this.a = b;
    }
    var Fa = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Ea.prototype.load = function(a) {
        var b = new B, c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
        va(d, e);
        var f = new ya(e);
        Da(f);
        z(c, wa(d), C(b));
        E(b, function() {
            a(f.a, f.c, Fa);
        });
    };
    function Ga(a, b) {
        this.c = a;
        this.a = b;
    }
    Ga.prototype.load = function(a) {
        var b = this.a.id, c = this.c.o;
        b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b) a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for(var e = [], f = 0; f < b.length; f += 2)for(var g = b[f], m = b[f + 1], h = 0; h < m.length; h++)e.push(new G(g, m[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    });
                } catch (l) {}
                a(e);
            }
        }, 2E3) : a([]);
    };
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.a = [];
    }
    Ha.prototype.load = function(a) {
        var b = this.f.id, c = this.c.o, d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b, c) {
            for(var g = 0, m = c.fonts.length; g < m; ++g){
                var h = c.fonts[g];
                d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
            }
            a(d.a);
        }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([]);
        })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
        return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
        return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
        return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
        return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
        return new Ea(b, a);
    };
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z;
    }) : $14aa168469b2616d$exports ? $14aa168469b2616d$exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
})();


// import { Orbit } from 'foundation-sites/js/foundation.orbit';
// import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu'; // 
// import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle'; // _jwp_nav-title-bar.php
// import { Reveal } from 'foundation-sites/js/foundation.reveal';
// import { Slider } from 'foundation-sites/js/foundation.slider';
// import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll';
// import { Sticky } from 'foundation-sites/js/foundation.sticky';
// import { Tabs } from 'foundation-sites/js/foundation.tabs';
// import { Toggler } from 'foundation-sites/js/foundation.toggler';
// import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
// import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';
(0, $4PYAy.Foundation).addToJquery((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))));
// Add Foundation Utils to Foundation global namespace for backwards
// compatibility.
// Foundation.rtl = CoreUtils.rtl;
// Foundation.GetYoDigits = CoreUtils.GetYoDigits;
// Foundation.transitionend = CoreUtils.transitionend;
// Foundation.RegExpEscape = CoreUtils.RegExpEscape;
// Foundation.onLoad = CoreUtils.onLoad;
(0, $4PYAy.Foundation).Box = (0, $1DEAP.Box);
// Foundation.onImagesLoaded = onImagesLoaded;
(0, $4PYAy.Foundation).Keyboard = (0, $kvWGb.Keyboard);
(0, $4PYAy.Foundation).MediaQuery = (0, $cvxXx.MediaQuery);
// Foundation.Motion = Motion;
// Foundation.Move = Move;
(0, $4PYAy.Foundation).Nest = (0, $7pq6k.Nest);
// Foundation.Timer = Timer;
// Touch and Triggers previously were almost purely sede effect driven,
// so no need to add it to Foundation, just init them.
// Disable Touch for off-canvas menu before initializing
// Touch.init($); // DISABLED - causes passive event listener issues
(0, $5EyIV.Triggers).init((0, (/*@__PURE__*/$parcel$interopDefault($cMmgH))), (0, $4PYAy.Foundation));
(0, $cvxXx.MediaQuery)._init();
// Foundation.plugin(Abide, 'Abide');
// Foundation.plugin(Accordion, 'Accordion');
(0, $4PYAy.Foundation).plugin((0, $jEMkX.AccordionMenu), 'AccordionMenu'); // 
// Foundation.plugin(Drilldown, 'Drilldown'); // 
// Foundation.plugin(Dropdown, 'Dropdown');
(0, $4PYAy.Foundation).plugin((0, $lbeA6.DropdownMenu), 'DropdownMenu'); // 
// Foundation.plugin(Equalizer, 'Equalizer');
// Foundation.plugin(Interchange, 'Interchange');
// Foundation.plugin(Magellan, 'Magellan');
(0, $4PYAy.Foundation).plugin((0, $lvQTI.OffCanvas), 'OffCanvas'); // 
// import particlesJS from "particle.js";
// let particlesJS = require("particle.js"); 
// import 'particle.js';
// initializer.key_initFoundation();
// jQuery(document).foundation();
// cannot apply update. Need to do a full reload - only accept if full relod is not needed
// if(module && module.hot){
//     module.hot.accept();
// }   
// ****************************** // 
// ****** WRAPPER  ****** // 
// ****************************** // 
// IIFE - Immediately Invoked Function Expression
(function(bptcode) {
    // The global jQuery object is passed as a parameter 
    bptcode(window.jQuery, window, document);
})(function($, window1, document1) {
    // function adjustMenuWidth(arg) {
    //     let argOffset = parseInt(arg) + 70;
    //     let argOffsetPixel = argOffset + 'px';
    //     console.log('width = ' + argOffsetPixel);
    //     $('#sub-menu .parent-width').css({
    //         'max-width': argOffsetPixel,
    //     });
    // }
    // $(window).on('load', function () {
    //     const parentMenuWidth = $('#main-nav-mega').css('width');
    //     adjustMenuWidth(parentMenuWidth);
    // });
    // $(window).on('load', function () {
    //     let parentMenuWidth = $('#main-nav-mega').css('width');
    //     adjustMenuWidth(parentMenuWidth); 
    // });
    // The $ is now locally scoped  
    $(document1).ready(function() {
        // *** CODE HERE *** //
        $(document1).foundation();
        // Force dropdown menu to use click only - destroy Foundation plugin and use custom handler
        setTimeout(function() {
            var $menu = $('#main-nav');
            if ($menu.length) {
                // DESTROY Foundation DropdownMenu plugin completely
                var plugin = $menu.data('zfPlugin');
                if (plugin && typeof plugin._destroy === 'function') plugin._destroy();
                // Remove all Foundation event listeners
                $menu.off();
                $menu.find('*').off();
                // Desktop click handler for menu-item-has-children using native JS
                var desktopMenu = document1.getElementById('main-nav');
                if (desktopMenu) {
                    var parentItems = desktopMenu.querySelectorAll('.menu-item-has-children');
                    parentItems.forEach(function(li) {
                        var link = li.querySelector(':scope > a');
                        if (link) link.addEventListener('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            // Close other open menus
                            parentItems.forEach(function(otherLi) {
                                if (otherLi !== li) otherLi.classList.remove('is-active');
                            });
                            // Toggle current menu
                            li.classList.toggle('is-active');
                        });
                    });
                    // Close menu when clicking outside
                    document1.addEventListener('click', function(e) {
                        if (!desktopMenu.contains(e.target)) parentItems.forEach(function(li) {
                            li.classList.remove('is-active');
                        });
                    });
                }
            }
            // Mobile menu - simple click handler (no Foundation plugin needed)
            var mobileMenu = document1.getElementById('offcanvas-nav');
            if (mobileMenu) {
                // Get all parent menu items and handle them
                var parentItems = mobileMenu.querySelectorAll('.menu-item-has-children');
                parentItems.forEach(function(li) {
                    var link = li.querySelector(':scope > a');
                    if (link) {
                        // Create a toggle button instead of using the link
                        var toggleBtn = document1.createElement('span');
                        toggleBtn.className = 'submenu-toggle';
                        toggleBtn.innerHTML = link.innerHTML;
                        toggleBtn.style.cursor = 'pointer';
                        toggleBtn.style.display = 'block';
                        toggleBtn.style.padding = link.style.padding || '10px 0';
                        toggleBtn.addEventListener('click', function(e) {
                            e.stopPropagation();
                            li.classList.toggle('is-active');
                        });
                        // Replace link with toggle button
                        link.parentNode.replaceChild(toggleBtn, link);
                    }
                });
            }
        }, 200);
        // if($('[data-equalizer]').length > 0){
        //     setTimeout(()=>Foundation.reInit('equalizer'), 250);
        // }
        var submitButton = '<div class="acf-submit-button"><input type="submit" class="button button-primary" value="Save Changes" /></div>';
        $('#acf-group_66efd3adfeae').append(submitButton);
        $14aa168469b2616d$exports.load({
            custom: {
                families: [
                    'Fira Code'
                ]
            }
        });
        $('.no-fouc').removeClass('no-fouc');
        //   const particlesJS = window.particlesJS;
        // ****** CTA ALERT BAR  ****** // 
        const ctaBar = document1.querySelector('[data-cta-bar]');
        const ctaBarClose = document1.querySelector('[data-cta-bar-close]');
        if (ctaBar && ctaBarClose) // Close button functionality
        ctaBarClose.addEventListener('click', function(e) {
            e.preventDefault();
            ctaBar.classList.add('is-hidden');
        });
    // ****** END CTA ALERT BAR ****** // 
    /**
         * File skip-link-focus-fix.js.
         *
         * Helps with accessibility for keyboard only users.
         *
         * Learn more: https://git.io/vWdr2
         */ // (function () {
    //     var isIe = /(trident|msie)/i.test(navigator.userAgent);
    //     if (isIe && document.getElementById && window.addEventListener) {
    //         window.addEventListener('hashchange', function () {
    //             var id = location.hash.substring(1),
    //                 element;
    //             if (!(/^[A-z0-9_-]+$/.test(id))) {
    //                 return;
    //             }
    //             element = document.getElementById(id);
    //             if (element) {
    //                 if (!(/^(?:a|select|input|button|textarea)$/i.test(element.tagName))) {
    //                     element.tabIndex = -1;
    //                 }
    //                 element.focus();
    //             }
    //         }, false);
    //     }
    // })();
    /*
        These functions make sure WordPress
        and Foundation play nice together.
        */ // Remove empty P tags created by WP inside of Accordion and Orbit
    // jQuery('.accordion p:empty, .orbit p:empty').remove();
    // Adds Flex Video to YouTube and Vimeo Embeds
    // jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    //     if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
    //         jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    //     } else {
    //         jQuery(this).wrap("<div class='responsive-embed'/>");
    //     }
    // });
    // $('.js-drilldown-back').each(function (e) {
    //     var backTxt = $(this).parent().closest('.is-drilldown-submenu-parent').find('> a').text();
    //     console.log(backTxt);
    //     var backTxtContent = '<div class="js-drilldown-arrow-left"><a tabindex="0"><span class="drilldown-title color-primary">' + backTxt + '</span></a></div>';
    //     $(this).html(backTxtContent);
    // });
    // $('#main-nav-mega').on('show.zf.dropdownMenu', function (ev, $el) {
    //     $el.css({
    //         "display": "none"
    //     }).fadeIn({
    //         easing: 'linear',
    //         duration: 125,
    //     });
    // });
    // $('#main-nav-mega').on('hide.zf.dropdownMenu', function (ev, $el) {
    //     console.log($(this));
    //     $el.find('span').remove();
    //     console.log('true');
    //     $el.children("ul")
    //         .css('display', 'inherit').fadeOut({
    //             easing: 'linear',
    //             duration: 125,
    //         });
    // });
    // const api = new WooCommerceRestApi({
    //     url: "https://template.local/",
    //     consumerKey: "ck_fe8a78457f7b0475305f23902cdab8939f34298b",
    //     consumerSecret: "cs_214cc49c40965b165ea092fb0f2a49b3dfeec40a",
    //     version: "wc/v3"
    // });
    // Create a product
    // api.post("products", {
    //     name: "Product Simple Affiliate Link", // See more in https://woocommerce.github.io/woocommerce-rest-api-docs/#product-properties
    //     type: "simple",
    //     fields:{
    //         'affiliate_link': 'https://en.wikipedia.org/wiki/Truck'
    //     }
    //     })
    //     .then((response) => {
    //         console.log('first response');
    //         console.log(response);
    //                     // List products
    // api.get("products", {
    //     per_page: 20, // 20 products per page
    // })
    // .then((response) => {
    // // Successful request
    // console.log("Response Status:", response.status);
    // console.log("Response Headers:", response.headers);
    // console.log("Response Data:", response.data);
    // console.log("Total of pages:", response.headers['x-wp-totalpages']);
    // console.log("Total of items:", response.headers['x-wp-total']);
    // })
    // .catch((error) => {
    // // Invalid request, for 4xx and 5xx statuses
    // console.log("Response Status:", error.response.status);
    // console.log("Response Headers:", error.response.headers);
    // console.log("Response Data:", error.response.data);
    // })
    // .finally(() => { 
    // // Always executed.
    // });
    //     })
    //     .catch((error) => {
    //         // Invalid request, for 4xx and 5xx statuses
    //         console.log("Response Status:", error.response.status);
    //         console.log("Response Headers:", error.response.headers);
    //         console.log("Response Data:", error.response.data);
    //     })
    //     .finally(() => {
    //         // Always executed.
    //     });
    // $.ajax({
    //     url: wpApiSettings.root + 'wc/v3/products?consumer_key=ck_fe8a78457f7b0475305f23902cdab8939f34298b&consumer_secret=cs_214cc49c40965b165ea092fb0f2a49b3dfeec40a',
    //     method: 'POST',
    //     beforeSend: function (xhr) {
    //         xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
    //     },
    //     data: {
    //         'name': 'New Post Title',
    //         'affiliate_link': 'testing-123'
    //     },
    //     dataType: 'json',
    // }).done(function (response) {
    //     console.log(response);
    // });
    // $.ajax({
    //     url: wpApiSettings.root + 'wp/v2/posts',
    //     method: 'POST',
    //     beforeSend: function (xhr) {
    //         xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
    //     },
    //     data: {
    //         'title': 'New Post Title',
    //         'fields': {
    //             '_affiliate_link': 'testing-123'
    //         }
    //     }
    // }).done(function (response) {
    //     console.log(response);
    // });
    // ****************************** // 
    // ****** IN THIS POST ****** // 
    // ****************************** //
    // function htmlBuilderP(ele) {
    //     if (ele.length > 0) {
    //         let html = '<ul class="dot" data-magellan data-offset="120">';
    //         let $count = 0;
    //         ele.each(function () {
    //             $(this).attr('id', `${$count}`);
    //             $(this).attr('data-magellan-target', `${$count}`);
    //             html += `<li><a href="#${$count}">${$(this).text()}</a></li>`;
    //             $count += 1;
    //         });
    //         html += '</ul>';
    //         $('.in-this-post .post__reading-time').after(html);
    //         $(".in-this-post").foundation();
    //     } else {
    //         $('.post-template-default.single .in-this-post h3').remove();
    //     }
    // }
    // htmlBuilderP($('.single .the_content>h2'));
    // AJAX FILTER 
    // if ($('#blogfilter').length > 0) {
    //     ajaxTestFunction(false, false);
    //     var $current;
    //     // Wrap the AJAX call to `test_function` in a `function`.
    //     function ajaxTestFunction(page_num, target) {
    //         // $('#response').delay(0).fadeOut({
    //         //     easing: 'linear',
    //         //     duration: 0,
    //         // }); // insert data
    //         if (target) {
    //             $current = target;
    //             var $currentID = $($current).val();
    //             var $category = $currentID;
    //         } else {
    //             var $category = -1;
    //         }
    //         if ($category == -1) {
    //             $('.featured__post').delay(0).fadeIn({
    //                 easing: 'linear',
    //                 duration: 0,
    //             });
    //         } else {
    //             $('.featured__post').delay(0).fadeOut({
    //                 easing: 'linear',
    //                 duration: 0,
    //             });
    //         }
    //         var $action = $('#blogfilter').attr('action');
    //         var $method = $('#blogfilter').attr('method');
    //         var data = {
    //             'action': 'blogajaxfilter',
    //             'category': $category,
    //             'paged': page_num || 1
    //         };
    //         $.ajax({
    //             url: $action,
    //             data: data, // form data
    //             type: $method, // POST
    //             beforeSend: function (xhr) {
    //                 // filter.find('button').text('Processing...');
    //                 // changing the button label
    //                 // $('.blog-featured').remove();
    //             },
    //             success: function (data) {
    //                 // filter.find('button').text('Apply filter');
    //                 // changing the button label back
    //                 $('#blogresponse').css({
    //                     'display': 'none'
    //                 }).html(data).delay(0).fadeIn({
    //                     easing: 'linear',
    //                     duration: 0,
    //                 });; // insert data
    //                 if (!page_num) {
    //                     // let $recentPost = $('#blogresponse .cell:first-of-type').detach();
    //                     // $('#blogresponse').before(`<div class="grid-x grid-margin-x blog-featured"></div>`);
    //                     // $('.blog-featured').append($recentPost);
    //                     // $('.blog-featured .cell').removeClass('large-4');
    //                     // $('.blog-featured .cell').addClass('large-6');
    //                 }
    //             }
    //         });
    //         return false;
    //     }
    //     $('.blog-filter-input-label').click(function (e) {
    //         // Starts at page #1 
    //         $(".blog-filter-input-label").not($(this)).removeClass('is-active');
    //         $(this).addClass('is-active');
    //     });
    //     $('#blogfilter').change(function (e) {
    //         // Starts at page #1 
    //         ajaxTestFunction(false, e.target);
    //     });
    //     // And add a listener/callback for the pagination clicks.
    //     $('#blogresponse').on('click', '.pagination a', function (e) {
    //         e.preventDefault();
    //         var paged = /[\?&]paged=(\d+)/.test(this.href) && RegExp.$1;
    //         ajaxTestFunction(paged, $current);
    //         console.log(paged);
    //         // $('html, body').animate({ scrollTop: 0 }, 1000);
    //         if (paged == 1) {
    //             const fade = {
    //                 opacity: 1,
    //                 transition: 'opacity 0.25s'
    //             };
    //             $('.featured__post').delay(0).fadeIn({
    //                 easing: 'linear',
    //                 duration: 0,
    //             });
    //         } else {
    //             const fade = {
    //                 opacity: 0,
    //                 transition: 'opacity 0.25s'
    //             };
    //             $('.featured__post').delay(0).fadeOut({
    //                 easing: 'linear',
    //                 duration: 0,
    //             });
    //         }
    //     });
    // }
    // ****************************** // 
    // ****** SLICK ****** // 
    // ****************************** // 
    //        $('.__slider').slick({
    //            infinite: true,
    //            speed: 300,
    //            nextArrow: $('.__next'),
    //            prevArrow: $('.__prev'),
    //            mobileFirst: true,
    //            responsive: [
    //                {
    //                    breakpoint: 1,
    //                    settings: {
    //                        slidesToShow: 1,
    //                        arrows: false,
    //                        dots: true,
    //                    }
    //             },
    //                {
    //                    breakpoint: 640,
    //                    settings: {
    //                        dots: true,
    //                        arrows: false,
    //                        slidesToShow: 2
    //                    }
    //             },
    //                {
    //                    breakpoint: 1024,
    //                    settings: {
    //                        dots: false,
    //                        arrows: true,
    //                        slidesToShow: 3
    //                    }
    //             }
    //        ]
    //        });
    //        // $('.__slider').slick('slickRemove', 0);
    // ****************************** // 
    // ****** END SLICK ****** // 
    // ****************************** // 
    // ****************************** // 
    // ****** WAYPOINTS ****** // 
    // ****************************** // 
    // new Waypoint({
    //     element: document.getElementsByClassName('about')[0],
    //     handler: function () {
    //         $('.about').addClass('animated');
    //         $('.about .about-split__left-container').addClass('about-split__left-container--active');
    //         $('.about .about-split__right-container').addClass('about-split__right-container--active');
    //     },
    //     // Offsets here
    //     offset: '45%'
    // })
    //    $('#waypoint-one').css('opacity', 0);
    //    $('.about').waypoint(function (el) {
    //        $('.about').addClass('animated');
    //        $('.about .about-split__left-container').addClass('about-split__left-container--active');
    //        $('.about .about-split__right-container').addClass('about-split__right-container--active');
    //    }, {
    //        // Offsets here
    //        offset: '60%'
    //    });
    // ****************************** // 
    // ****** END WAYPOINTS ****** // 
    // ****************************** //  
    // *** END CODE *** //
    // ****************************** // 
    // ****** END WRAPPER  ****** // 
    // ****************************** //
    });
});

})();
//# sourceMappingURL=theme.js.map
